(function() {
  'use strict';
  const CUSTOMER = window.__S3.customer;

  function getBrowserId() {
    let id = localStorage.getItem('lb_id');
    if (!id) {
      var arr = new Uint8Array(16);
      (window.crypto || window.msCrypto).getRandomValues(arr);
      id = 'lb_' + Array.from(arr, function(b) { return b.toString(16).padStart(2,'0'); }).join('');
      localStorage.setItem('lb_id', id);
    }
    return id;
  }

  function clearChildren(el) { while (el && el.firstChild) el.removeChild(el.firstChild); }
  function escapeHTML(str) { var d = document.createElement('div'); d.textContent = str; return d.innerHTML; }

  async function fetchCreditsFromServer() {
    try {
      var resp = await fetch(CONFIG.API_BASE + '/api/lucy/wallet/balance?browser_id=' + encodeURIComponent(getBrowserId()));
      var data = await resp.json();
      if (data.free_remaining !== undefined) {
        state.credits = data.free_remaining.design !== undefined ? data.free_remaining.design : 3;
        state.creditsLoaded = true;
      } else {
        state.credits = 3;
        state.creditsLoaded = true;
      }
    } catch(e) {
      state.credits = 3;
      state.creditsLoaded = true;
    }
    if (els.creditsNum) els.creditsNum.textContent = state.credits;
  }

  async function spendCreditOnServer() {
    try {
      var resp = await fetch(CONFIG.API_BASE + '/api/lucy/wallet/spend', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ browser_id: getBrowserId(), service: 'design' })
      });
      var data = await resp.json();
      if (!data.ok) return false;
      state.credits = Math.max(0, state.credits - 1);
      if (els.creditsNum) els.creditsNum.textContent = state.credits;
      fetchCreditsFromServer();
      return true;
    } catch(e) {
      return false;
    }
  }
  (function initLoginGate() {
    var gate = document.getElementById('s3LoginGate');
    if (!gate) return;
    if (!CUSTOMER.loggedIn) {
      gate.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    } else {
      gate.style.display = 'none';
      var browserId = getBrowserId();
      if (browserId && CUSTOMER.id) {
        fetch('https://ai-api.wowstore.live/api/lucy/design/link-account', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ browser_id: browserId, shopify_customer_id: CUSTOMER.id })
        }).catch(function() {});
      }
    }
  })();
  var MyDesigns = {
    page: 1, filter: 'all', totalPages: 1,
    open: function() {
      var overlay = document.getElementById('s3MyDesignsOverlay');
      if (overlay) { overlay.style.display = 'block'; this.load(); }
    },
    close: function() {
      var overlay = document.getElementById('s3MyDesignsOverlay');
      if (overlay) overlay.style.display = 'none';
    },
    load: function() {
      var grid = document.getElementById('s3MyDesignsGrid');
      var loading = document.getElementById('s3MyDesignsLoading');
      if (loading) loading.style.display = 'block';
      var params = new URLSearchParams({ page: this.page, limit: 20 });
      if (CUSTOMER.loggedIn && CUSTOMER.id) params.set('shopify_customer_id', CUSTOMER.id);
      else params.set('browser_id', getBrowserId());
      fetch('https://ai-api.wowstore.live/api/lucy/design/my-designs?' + params.toString())
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (loading) loading.style.display = 'none';
          MyDesigns.totalPages = data.pages || 1;
          MyDesigns.renderDesigns(data.designs || [], grid);
          MyDesigns.updatePagination();
        }).catch(function() {
          if (loading) loading.style.display = 'none';
          if (grid) {
            clearChildren(grid);
            var msg = document.createElement('div');
            msg.className = 's3-mydesigns-empty';
            msg.textContent = 'Could not load designs. Please try again.';
            grid.appendChild(msg);
          }
        });
    },
    renderDesigns: function(designs, grid) {
      if (!grid) return;
      clearChildren(grid);
      if (!designs.length) {
        var empty = document.createElement('div');
        empty.className = 's3-mydesigns-empty';
        var icon = document.createElement('div');
        icon.className = 's3-mydesigns-empty-icon';
        icon.textContent = '\uD83C\uDFA8';
        var text = document.createElement('div');
        text.className = 's3-mydesigns-empty-text';
        text.textContent = 'No designs yet. Create your first design in the studio!';
        empty.appendChild(icon);
        empty.appendChild(text);
        grid.appendChild(empty);
        return;
      }
      var filt = MyDesigns.filter;
      designs.forEach(function(d) {
        if (filt !== 'all' && d.stage !== filt) return;
        var card = document.createElement('div');
        card.className = 's3-design-card';
        var img = document.createElement('img');
        img.className = 's3-design-card-img';
        img.src = d.thumbnail_url || d.design_url || '';
        img.alt = 'Design';
        img.loading = 'lazy';
        card.appendChild(img);
        var body = document.createElement('div');
        body.className = 's3-design-card-body';
        var prompt = document.createElement('p');
        prompt.className = 's3-design-card-prompt';
        prompt.textContent = d.prompt || '';
        body.appendChild(prompt);
        var meta = document.createElement('div');
        meta.className = 's3-design-card-meta';
        var dateEl = document.createElement('span');
        dateEl.textContent = new Date(d.created_at).toLocaleDateString();
        var stageEl = document.createElement('span');
        stageEl.textContent = d.stage === 'stage3' ? 'Ultra' : 'Studio';
        meta.appendChild(dateEl);
        meta.appendChild(stageEl);
        body.appendChild(meta);
        var actions = document.createElement('div');
        actions.className = 's3-design-card-actions';
        var useBtn = document.createElement('button');
        useBtn.className = 's3-design-card-btn s3-btn-use';
        useBtn.textContent = 'Re-use';
        useBtn.addEventListener('click', function() { MyDesigns.reuseDesign(d); });
        var delBtn = document.createElement('button');
        delBtn.className = 's3-design-card-btn s3-btn-del';
        delBtn.textContent = 'Delete';
        delBtn.addEventListener('click', function() { MyDesigns.deleteDesign(d.id, card); });
        actions.appendChild(useBtn);
        actions.appendChild(delBtn);
        body.appendChild(actions);
        card.appendChild(body);
        grid.appendChild(card);
      });
    },
    updatePagination: function() {
      var pag = document.getElementById('s3MyDesignsPagination');
      var prevB = document.getElementById('s3MyDesignsPrev');
      var nextB = document.getElementById('s3MyDesignsNext');
      var pageEl = document.getElementById('s3MyDesignsPage');
      if (!pag) return;
      pag.style.display = this.totalPages > 1 ? 'flex' : 'none';
      if (pageEl) pageEl.textContent = this.page + ' / ' + this.totalPages;
      if (prevB) prevB.disabled = this.page <= 1;
      if (nextB) nextB.disabled = this.page >= this.totalPages;
    },
    reuseDesign: function(d) {
      var promptInput = document.getElementById('s3PromptInput') || document.querySelector('textarea[id*="Prompt"]');
      if (promptInput && d.prompt) { promptInput.value = d.prompt; promptInput.dispatchEvent(new Event('input')); }
      this.close();
    },
    deleteDesign: function(designId, card) {
      if (!confirm('Delete this design?')) return;
      var params = new URLSearchParams();
      if (CUSTOMER.loggedIn && CUSTOMER.id) params.set('shopify_customer_id', CUSTOMER.id);
      else params.set('browser_id', getBrowserId());
      fetch('https://ai-api.wowstore.live/api/lucy/design/' + designId + '?' + params.toString(), { method: 'DELETE' })
        .then(function(r) { return r.json(); })
        .then(function(data) { if (data.success && card) card.remove(); })
        .catch(function() {});
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    var btn = document.getElementById('s3MyDesignsBtn');
    if (btn) btn.addEventListener('click', function() { MyDesigns.open(); });
    var closeBtn = document.getElementById('s3MyDesignsClose');
    if (closeBtn) closeBtn.addEventListener('click', function() { MyDesigns.close(); });
    var bg = document.getElementById('s3MyDesignsBg');
    if (bg) bg.addEventListener('click', function() { MyDesigns.close(); });
    document.querySelectorAll('.s3-mydesigns-filter').forEach(function(f) {
      f.addEventListener('click', function() {
        document.querySelectorAll('.s3-mydesigns-filter').forEach(function(b) { b.classList.remove('active'); });
        f.classList.add('active');
        MyDesigns.filter = f.dataset.filter;
        MyDesigns.page = 1;
        MyDesigns.load();
      });
    });
    var prevBtn = document.getElementById('s3MyDesignsPrev');
    if (prevBtn) prevBtn.addEventListener('click', function() { if (MyDesigns.page > 1) { MyDesigns.page--; MyDesigns.load(); } });
    var nextBtn = document.getElementById('s3MyDesignsNext');
    if (nextBtn) nextBtn.addEventListener('click', function() { if (MyDesigns.page < MyDesigns.totalPages) { MyDesigns.page++; MyDesigns.load(); } });
  });
  const CONFIG = {
    API_BASE: window.__S3.api,
    VIRTUE_PERCENTAGE: 0.05,

    PRODUCT_CATEGORIES: {
      apparel: { name: 'Apparel', icon: '👕' },
      accessories: { name: 'Accessories', icon: '📱' },
      home: { name: 'Home & Living', icon: '🏠' },
      kids: { name: 'Kids & Baby', icon: '👶' },
      specialty: { name: 'Specialty', icon: '✨' }
    },

    PRODUCTS: {
      tshirt: { name: 'T-Shirt', price: 24.99, sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'], category: 'apparel', icon: '👕', img: window.__S3.assets['gelato-tshirt-flatlay.webp'], zones: ['front', 'back', 'inside_label', 'outside_label'] },
      hoodie: { name: 'Hoodie', price: 49.99, sizes: ['S', 'M', 'L', 'XL', '2XL'], category: 'apparel', icon: '🧥', img: window.__S3.assets['gelato-hoodie-flatlay.webp'], zones: ['front', 'back', 'large_back', 'left_sleeve', 'right_sleeve', 'inside_label', 'outside_label'] },
      sweatshirt: { name: 'Sweatshirt', price: 39.99, sizes: ['S', 'M', 'L', 'XL', '2XL'], category: 'apparel', icon: '👔', img: window.__S3.assets['gelato-hoodie-flatlay.webp'], zones: ['front', 'back', 'inside_label', 'outside_label'] },
      longsleeve: { name: 'Long Sleeve', price: 29.99, sizes: ['S', 'M', 'L', 'XL', '2XL'], category: 'apparel', icon: '🎽', img: window.__S3.assets['gelato-tshirt-flatlay.webp'], zones: ['front', 'back', 'left_sleeve', 'right_sleeve', 'inside_label', 'outside_label'] },
      tank: { name: 'Tank Top', price: 19.99, sizes: ['XS', 'S', 'M', 'L', 'XL'], category: 'apparel', icon: '🩱', img: window.__S3.assets['gelato-tshirt-flatlay.webp'], zones: ['front', 'back', 'inside_label', 'outside_label'] },
      croptop: { name: 'Crop Top', price: 22.99, sizes: ['XS', 'S', 'M', 'L', 'XL'], category: 'apparel', icon: '👚', img: window.__S3.assets['gelato-tshirt-flatlay.webp'], zones: ['front', 'back', 'inside_label', 'outside_label'] },
      phonecase: { name: 'Phone Case', price: 19.99, sizes: ['iPhone 14', 'iPhone 15', 'iPhone 15 Pro', 'Samsung S23', 'Samsung S24'], category: 'accessories', icon: '📱', img: window.__S3.assets['gelato-phonecase-flatlay.jpg'], zones: ['back'] },
      totebag: { name: 'Tote Bag', price: 24.99, sizes: ['Standard'], category: 'accessories', icon: '👜', img: window.__S3.assets['gelato-tote-flatlay.jpg'], zones: ['front', 'back'] },
      hat: { name: 'Baseball Cap', price: 24.99, sizes: ['One Size'], category: 'accessories', icon: '🧢', img: window.__S3.assets['gelato-tote-flatlay.jpg'], zones: ['front'] },
      beanie: { name: 'Beanie', price: 22.99, sizes: ['One Size'], category: 'accessories', icon: '🎩', img: window.__S3.assets['gelato-tote-flatlay.jpg'], zones: ['front'] },
      mug: { name: 'Ceramic Mug', price: 14.99, sizes: ['11oz', '15oz'], category: 'home', icon: '☕', img: window.__S3.assets['gelato-mug-white.jpg'], zones: ['wrap'] },
      poster: { name: 'Poster', price: 19.99, sizes: ['12x16', '18x24', '24x36'], category: 'home', icon: '🖼️', img: window.__S3.assets['gelato-poster-flatlay.jpg'], zones: ['front'] },
      canvas: { name: 'Canvas Print', price: 39.99, sizes: ['12x12', '16x20', '24x36'], category: 'home', icon: '🎨', img: window.__S3.assets['gelato-canvas-flatlay.jpg'], zones: ['front'] },
      pillow: { name: 'Throw Pillow', price: 29.99, sizes: ['14x14', '18x18', '20x20'], category: 'home', icon: '🛋️', img: window.__S3.assets['gelato-canvas-flatlay.jpg'], zones: ['front', 'back'] },
      blanket: { name: 'Throw Blanket', price: 49.99, sizes: ['50x60'], category: 'home', icon: '🛏️', img: window.__S3.assets['gelato-canvas-flatlay.jpg'], zones: ['front'] },
      babyonesie: { name: 'Baby Onesie', price: 19.99, sizes: ['0-3M', '3-6M', '6-12M', '12-18M'], category: 'kids', icon: '👶', img: window.__S3.assets['gelato-tshirt-flatlay.webp'], zones: ['front', 'back', 'inside_label'] },
      kidstee: { name: 'Kids T-Shirt', price: 17.99, sizes: ['2T', '3T', '4T', '5T', 'Youth S', 'Youth M', 'Youth L'], category: 'kids', icon: '🧒', img: window.__S3.assets['gelato-tshirt-flatlay.webp'], zones: ['front', 'back', 'inside_label', 'outside_label'] }
    },

    ZONE_IMAGES: (function(){var tb=window.__S3.assets['tshirt-back-flatlay.jpg'],hb=window.__S3.assets['hoodie-back-flatlay.jpg'],sl=window.__S3.assets['tshirt-sleeve-closeup.jpg'],nk=window.__S3.assets['tshirt-neck-closeup.jpg'];return{
      tshirt:{back:tb,inside_label:nk,outside_label:nk},
      hoodie:{back:hb,large_back:hb,left_sleeve:sl,right_sleeve:sl,inside_label:nk,outside_label:nk},
      sweatshirt:{back:hb,inside_label:nk,outside_label:nk},
      longsleeve:{back:tb,left_sleeve:sl,right_sleeve:sl,inside_label:nk,outside_label:nk},
      tank:{back:tb,inside_label:nk,outside_label:nk},
      croptop:{back:tb,inside_label:nk,outside_label:nk},
      babyonesie:{back:tb,inside_label:nk},
      kidstee:{back:tb,inside_label:nk,outside_label:nk}
    }})(),

    BRANDING: {
      inside_label: { name: 'Inside Neck Label', price: 4.99, description: 'Custom woven label inside the collar' },
      outside_label: { name: 'Outside Label', price: 6.99, description: 'Premium woven label on outside' },
      hang_tag: { name: 'Custom Hang Tag', price: 3.99, description: 'Branded swing tag with your logo' }
    },
    PACKAGING: {
      custom_box: { name: 'Custom Mailer Box', price: 8.99, description: 'Branded box with your design' },
      tissue_paper: { name: 'Branded Tissue', price: 2.99, description: 'Custom printed tissue paper' },
      sticker_pack: { name: 'Sticker Pack-in', price: 1.99, description: 'Custom stickers in every order' },
      thank_you_card: { name: 'Thank You Card', price: 1.49, description: 'Personalized thank you card' },
      packing_slip: { name: 'Custom Packing Slip', price: 0, description: 'Your logo on the packing slip' }
    },

    ZONES: {
      front: { name: 'Front', price: 0, view: 'front' },
      back: { name: 'Back', price: 4.99, view: 'back' },
      large_back: { name: 'Large Back', price: 6.99, view: 'large_back' },
      outside_label: { name: 'Outside Label', price: 3.99, view: 'outside_label' },
      inside_label: { name: 'Inside Label', price: 1.99, view: 'inside_label' },
      left_sleeve: { name: 'Left Sleeve', price: 2.99, view: 'left_sleeve' },
      right_sleeve: { name: 'Right Sleeve', price: 2.99, view: 'right_sleeve' }
    },

    WORD_ROTATE: ['Closet', 'Movement', 'Brand', 'Legacy', 'Future'],

    TIPS: ['Add "detailed" for intricate designs','Specify colors for vibrancy','Try "minimalist" or "vintage" styles'],
    LUCY_GREETINGS: ["Welcome! I'm Lucy, your AI design assistant.","Hey! Tell me your vision.","Hi! What would you like to design?"]
  };
  const state = {
    activeZone: 'front',
    designs: new Map(),
    prompt: '',
    style: 'minimalist',
    model: 'seadream',
    product: 'tshirt',
    productCategory: 'apparel',
    color: '#FFFFFF',
    size: 'M',
    quantity: 1,
    generating: false,
    credits: 0,
    creditsLoaded: false,
    activeProductTab: 'apparel',
    shownPostGenUpsell: false,
    lucyListening: false,
    lucySpeaking: false,
    closet: JSON.parse(localStorage.getItem('s3_closet') || '[]'),
    brand: { name: '', tagline: '', logo: null, colors: {}, causes: [] },
    brandStep: 1,
    currentTier: 1,
    branding: {
      enabled: false,
      insideLabel: { enabled: false, design: null },
      outsideLabel: { enabled: false, design: null },
      hangTag: { enabled: false, design: null }
    },
    packaging: {
      enabled: false,
      customBox: { enabled: false, design: null },
      tissuePaper: { enabled: false },
      stickerPack: { enabled: false, design: null },
      thankYouCard: { enabled: false, message: '' },
      packingSlip: { enabled: true, logo: null }
    },
    orderTier: 'creative_spark',
    printMethod: 'dtg',
    printMethods: ['dtg'],
    printMethodDetails: []
  };
  let els = {};

  function cacheElements() {
    els = {
      prompt: document.getElementById('s3PromptInput'),
      charCount: document.getElementById('s3CharCount'),
      zoneTag: document.getElementById('s3ZoneTag'),
      creditsNum: document.getElementById('s3CreditsNum'),
      generateBtn: document.getElementById('s3GenerateBtn'),
      totalPrice: document.getElementById('s3TotalPrice'),
      virtueAmount: document.getElementById('s3VirtueAmount'),
      impactAmount: document.getElementById('s3ImpactAmount'),
      qtyValue: document.getElementById('s3QtyValue'),
      orderItems: document.getElementById('s3OrderItems'),
      lucyChat: document.getElementById('s3LucyChat'),
      lucyWave: document.getElementById('s3LucyWave'),
      lucyStatus: document.getElementById('s3LucyStatus'),
      voiceBtn: document.getElementById('s3VoiceBtn'),
      generating: document.getElementById('s3Generating'),
      genBar: document.getElementById('s3GenBar'),
      genTitle: document.getElementById('s3GenTitle'),
      genTip: document.getElementById('s3GenTip'),
      successModal: document.getElementById('s3SuccessModal'),
      brandModal: document.getElementById('s3BrandModal'),
      closetModal: document.getElementById('s3ClosetModal'),
      closetGrid: document.getElementById('s3ClosetGrid'),
      closetCount: document.getElementById('s3ClosetCount'),
      tryOnModal: document.getElementById('s3TryOnModal'),
      tryOnPreview: document.getElementById('s3TryOnPreview'),
      previewAvatar: document.getElementById('s3PreviewAvatar'),
      previewDesign: document.getElementById('s3PreviewDesign'),
      wordRotate: document.getElementById('s3WordRotate')
    };
  }
  function init() {
    if ('speechSynthesis' in window) {
      speechSynthesis.getVoices();
      speechSynthesis.onvoiceschanged = () => speechSynthesis.getVoices();
    }
    cacheElements();
    bindEvents();
    loadFromSession();
    updateUI();
    startWordRotation();
    lucyGreet();
    initMovementMaker();
    initInlineCreatorStories();
    initUpsellCarousel();
    checkApiHealth();
    loadClosetToGallery();
    loadS3PrintMethods(state.product);
    initProductCarousel();
    buildZoneStrip();
  }

  function applyProductColor(hex) {
    var containers = document.querySelectorAll('.s3-product-container');
    var bases = document.querySelectorAll('.s3-product-base');
    var isWhite = !hex || hex.toUpperCase() === '#FFFFFF' || hex.toUpperCase() === '#FFF';
    containers.forEach(function(c) { c.style.backgroundColor = isWhite ? '#fff' : hex; });
    bases.forEach(function(b) {
      if (isWhite) { b.classList.remove('color-tinted'); }
      else { b.classList.add('color-tinted'); }
    });
  }

  function buildZoneStrip() {
    var strip = document.getElementById('s3ZoneTabs');
    if (!strip) return;
    while (strip.firstChild) strip.removeChild(strip.firstChild);
    var product = CONFIG.PRODUCTS[state.product];
    if (!product) return;
    var zones = product.zones || ['front'];
    var zoneNames = {front:'Front',back:'Back',large_back:'Large Back',left_sleeve:'Left sleeve',right_sleeve:'Right sleeve',inside_label:'Inner neck',outside_label:'Outer neck',wrap:'Wrap'};
    var defaultImg = product.img || '';
    var zoneImgs = CONFIG.ZONE_IMAGES[state.product] || {};
    zones.forEach(function(z) {
      var btn = document.createElement('button');
      btn.className = 's3-zone-tab' + (z === state.activeZone ? ' active' : '');
      btn.setAttribute('data-zone', z);
      var thumb = document.createElement('span');
      thumb.className = 's3-zt-thumb';
      thumb.setAttribute('data-zone', z);
      var src = zoneImgs[z] || defaultImg;
      if (src) {
        var img = document.createElement('img');
        img.className = 's3-zt-img';
        img.src = src;
        img.alt = zoneNames[z] || z;
        img.loading = 'lazy';
        thumb.appendChild(img);
      }
      var name = document.createElement('span');
      name.className = 's3-tab-name';
      name.textContent = zoneNames[z] || z;
      btn.appendChild(thumb);
      btn.appendChild(name);
      btn.addEventListener('click', function() { selectZone(z); });
      strip.appendChild(btn);
    });
  }

  const CREATOR_STORIES = [
    {
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=48&h=48&fit=crop',
      quote: '"Design unique products and sell worldwide — no inventory needed."',
      name: 'Fashion Creator',
      stats: 'Earn per sale'
    },
    {
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=48&h=48&fit=crop',
      quote: '"5% of each sale goes to a cause the buyer chooses."',
      name: 'Impact Creator',
      stats: '5% to a cause you choose'
    },
    {
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=48&h=48&fit=crop',
      quote: '"No design skills needed — AI creates professional artwork."',
      name: 'Student Creator',
      stats: 'Ship worldwide'
    },
    {
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=48&h=48&fit=crop',
      quote: '"3 free AI designs every day. Start creating now."',
      name: 'New Creator',
      stats: '3 free/day'
    },
    {
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=48&h=48&fit=crop',
      quote: '"DTG, DTF, and Embroidery — pick the perfect print method."',
      name: 'Print Creator',
      stats: '15+ products'
    }
  ];

  let storyIndex = 0;

  function initInlineCreatorStories() {
    setInterval(() => {
      storyIndex = (storyIndex + 1) % CREATOR_STORIES.length;
      updateInlineStory();
    }, 8000);
  }

  function updateInlineStory() {
    const story = CREATOR_STORIES[storyIndex];
    const container = document.getElementById('s3InlineStory');
    if (!container) return;
    container.style.opacity = '0';
    container.style.transform = 'translateY(8px)';

    setTimeout(() => {
      document.getElementById('s3StoryAvatar').src = story.avatar;
      document.getElementById('s3StoryQuote').textContent = story.quote;
      document.getElementById('s3StoryName').textContent = story.name;
      document.getElementById('s3StoryStats').textContent = story.stats;
      container.style.opacity = '1';
      container.style.transform = 'translateY(0)';
    }, 300);
  }
  let tCarouselIndex = 0;
  let tCarouselInterval = null;
  let tCarouselPaused = false;
  const T_CAROUSEL_INTERVAL_MS = 7000;
  const T_TOTAL_SLIDES = 5;

  function initUpsellCarousel() {
    const carousel = document.getElementById('s3ToolbarCarousel');
    if (!carousel) return;
    const dots = document.querySelectorAll('.s3-tdot');
    dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.stopPropagation();
        goToTSlide(index);
        resetTCarouselTimer();
      });
    });
    carousel.addEventListener('mouseenter', () => {
      tCarouselPaused = true;
    });

    carousel.addEventListener('mouseleave', () => {
      tCarouselPaused = false;
      resetTCarouselTimer();
    });
    carousel.addEventListener('click', () => {
      nextTSlide();
      resetTCarouselTimer();
    });
    startTCarousel();
  }

  function startTCarousel() {
    tCarouselInterval = setInterval(() => {
      if (!tCarouselPaused) {
        nextTSlide();
      }
    }, T_CAROUSEL_INTERVAL_MS);
  }

  function nextTSlide() {
    tCarouselIndex = (tCarouselIndex + 1) % T_TOTAL_SLIDES;
    goToTSlide(tCarouselIndex);
  }

  function goToTSlide(index) {
    tCarouselIndex = index;
    const slides = document.querySelectorAll('.s3-tcarousel-slide');
    const dots = document.querySelectorAll('.s3-tdot');
    slides.forEach((slide, i) => { slide.classList.toggle('active', i === index); });

    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }

  function resetTCarouselTimer() {
    if (tCarouselInterval) {
      clearInterval(tCarouselInterval);
    }
    startTCarousel();
  }

  window.showPackagingModal = function() {
    const modal = document.getElementById('s3PackagingModal');
    if (modal) modal.classList.add('active');
  };

  function loadFromSession() {
    const savedDesign = sessionStorage.getItem('wowstore_design');
    const savedPrompt = sessionStorage.getItem('wowstore_prompt');

    if (savedDesign) {
      state.designs.set('front', {
        url: savedDesign,
        prompt: savedPrompt || ''
      });
      applyDesignToZone('front', savedDesign);
      updateZoneStatus('front', true);
      lucySay("I see you've started a design in Stage 2! Let's enhance it with more zones.");
    }

    fetchCreditsFromServer();
  }
  var PDESC = {
    tshirt:{d:'Premium cotton',c:'/collections/t-shirts'},
    hoodie:{d:'Heavyweight cotton-poly, brushed fleece',c:'/collections/hoodies'},
    sweatshirt:{d:'Midweight cotton-poly, relaxed fit',c:'/collections/sweatshirts'},
    longsleeve:{d:'Ring-spun cotton, ribbed cuffs',c:'/collections/long-sleeves'},
    tank:{d:'Lightweight cotton, warm weather',c:'/collections/tank-tops'},
    croptop:{d:'Cropped fit, soft cotton blend',c:'/collections/crop-tops'},
    phonecase:{d:'Impact-resistant, raised edges',c:'/collections/phone-cases'},
    totebag:{d:'Durable canvas, reinforced straps',c:'/collections/tote-bags'},
    hat:{d:'Structured 6-panel snapback',c:'/collections/hats'},
    beanie:{d:'Soft knit acrylic, turn-up cuff',c:'/collections/beanies'},
    mug:{d:'Ceramic, dishwasher safe',c:'/collections/mugs'},
    poster:{d:'Giclée print, archival paper',c:'/collections/posters'},
    canvas:{d:'Gallery-wrapped, wood frame',c:'/collections/canvas-prints'},
    pillow:{d:'Double-sided print, zipper',c:'/collections/pillows'},
    blanket:{d:'Sherpa fleece, machine wash',c:'/collections/blankets'},
    babyonesie:{d:'Cotton, snap closure',c:'/collections/baby'},
    kidstee:{d:'Pre-shrunk cotton, child-safe',c:'/collections/kids'}
  };

  function initProductCarousel() {
    var track = document.getElementById('s3CarouselTrack');
    if (!track) return;
    var products = CONFIG.PRODUCTS;
    var keys = Object.keys(products);
    var fragment = document.createDocumentFragment();
    function makeItem(key) {
      var p = products[key];
      var el = document.createElement('div');
      el.className = 's3-carousel-item' + (key === state.product ? ' active' : '');
      el.setAttribute('data-product', key);
      if (p.img) {
        var img = document.createElement('img');
        img.className = 's3-ci-img';
        img.src = p.img;
        img.alt = p.name;
        img.loading = 'lazy';
        el.appendChild(img);
      } else {
        var icon = document.createElement('span');
        icon.style.fontSize = '28px';
        icon.textContent = p.icon;
        el.appendChild(icon);
      }
      var name = document.createElement('span');
      name.className = 's3-ci-name';
      name.textContent = p.name;
      el.appendChild(name);
      el.addEventListener('click', function() {
        selectProductCarousel(key);
      });
      return el;
    }
    keys.forEach(function(key) { fragment.appendChild(makeItem(key)); });
    track.appendChild(fragment);
    updateProductInfo(state.product);
    var activeEl = track.querySelector('.s3-carousel-item.active');
    if (activeEl) { var scroll = track.parentElement; if (scroll) scroll.scrollLeft = Math.max(0, activeEl.offsetLeft - scroll.offsetWidth / 2 + activeEl.offsetWidth / 2); }
  }

  function selectProductCarousel(key) {
    state.product = key;
    state.productCategory = CONFIG.PRODUCTS[key]?.category || 'apparel';
    document.querySelectorAll('.s3-carousel-item').forEach(function(el) { el.classList.toggle('active', el.getAttribute('data-product') === key); });
    document.querySelectorAll('.s3-product-type').forEach(function(b) { b.classList.remove('active'); });
    var oldBtn = document.querySelector('.s3-product-type[data-product="' + key + '"]');
    if (oldBtn) oldBtn.classList.add('active');
    var track = document.getElementById('s3CarouselTrack');
    if(track){var a=track.querySelector('.s3-carousel-item.active');if(a){var scroll=track.parentElement;if(scroll)scroll.scrollTo({left:Math.max(0,a.offsetLeft-scroll.offsetWidth/2+a.offsetWidth/2),behavior:'smooth'});}}
    updatePrice();
    updateSizes();
    updateAvailableZones();
    loadS3PrintMethods(key);
    updateProductInfo(key);
  }

  function updateProductInfo(key) {
    var info = PDESC[key] || {};
    var p = CONFIG.PRODUCTS[key];
    if (!p) return;
    var n = document.getElementById('s3ProductInfoName');
    var d = document.getElementById('s3ProductInfoDesc');
    var l = document.getElementById('s3ProductInfoLink');
    if (n) n.textContent = p.name;
    if (d) d.textContent = (info.d || 'Premium quality') + '. Printed on demand, shipped worldwide.';
    if (l) l.href = info.c || '/collections';
  }

  window.UltraStudio = {
    selectProduct: function(key) {
      if (CONFIG.PRODUCTS[key]) {
        selectProductCarousel(key);
        lucySay("I've selected the " + CONFIG.PRODUCTS[key].name + " for you! " + CONFIG.PRODUCTS[key].icon);
      }
    },
    setPrompt: function(text) {
      if (els.prompt) {
        els.prompt.value = text;
        state.prompt = text;
        lucySay("I've written a prompt for you: \"" + text.substring(0, 60) + (text.length > 60 ? '...' : '') + "\" — hit Generate when you're ready!");
      }
    },
    getState: function() { return { product: state.product, prompt: state.prompt || '', printMethod: state.printMethod }; }
  };

  function bindEvents() {
    els.prompt?.addEventListener('input', function() {
      state.prompt = this.value;
      updateCharCount();
    });

    document.querySelectorAll('.s3-zone-tab').forEach(tab => { tab.addEventListener('click', () => selectZone(tab.dataset.zone)); });

    document.querySelectorAll('.s3-style-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.s3-style-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        state.style = this.dataset.style;
      });
    });

    document.querySelectorAll('.s3-model').forEach(m => {
      m.addEventListener('click', function() {
        document.querySelectorAll('.s3-model').forEach(x => x.classList.remove('active'));
        this.classList.add('active');
        state.model = this.dataset.model;
      });
    });

    els.generateBtn?.addEventListener('click', generateDesign);

    document.getElementById('s3EnhancePrompt')?.addEventListener('click', enhancePrompt);
    document.getElementById('s3RandomPrompt')?.addEventListener('click', randomPrompt);

    document.querySelectorAll('.s3-category-tab').forEach(tab => { tab.addEventListener('click', function() { const category = this.dataset.category; selectCategory(category); });
    });

    document.querySelectorAll('.s3-product-type').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.s3-product-type').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        state.product = this.dataset.product;
        state.productCategory = CONFIG.PRODUCTS[state.product]?.category || 'apparel';
        updatePrice();
        updateSizes();
        updateAvailableZones();
        loadS3PrintMethods(state.product);
      });
    });

    document.querySelectorAll('.s3-color').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.s3-color').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        state.color = this.dataset.color;
        applyProductColor(this.dataset.color);
      });
    });

    document.querySelectorAll('.s3-size').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.s3-size').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        state.size = this.dataset.size;
      });
    });

    document.getElementById('s3QtyMinus')?.addEventListener('click', () => {
      if (state.quantity > 1) {
        state.quantity--;
        els.qtyValue.textContent = state.quantity;
        updatePrice();
      }
    });

    document.getElementById('s3QtyPlus')?.addEventListener('click', () => {
      if (state.quantity < 10) {
        state.quantity++;
        els.qtyValue.textContent = state.quantity;
        updatePrice();
      }
    });

    document.getElementById('s3AddToCart')?.addEventListener('click', addToCart);
    document.getElementById('s3SaveToCloset')?.addEventListener('click', saveToCloset);

    document.getElementById('s3TryOnBtn')?.addEventListener('click', openTryOnModal);
    document.getElementById('s3CloseTryOn')?.addEventListener('click', closeTryOnModal);

    document.querySelectorAll('.s3-tryon-tab').forEach(tab => { tab.addEventListener('click', () => switchTryOnTab(tab.dataset.tab)); });

    document.querySelectorAll('.s3-avatar-item').forEach(item => { item.addEventListener('click', () => selectAvatar(item)); });

    const uploadZone = document.getElementById('s3PhotoUploadZone');
    const photoInput = document.getElementById('s3PhotoInput');
    uploadZone?.addEventListener('click', () => photoInput?.click());
    uploadZone?.addEventListener('dragover', handleDragOver);
    uploadZone?.addEventListener('dragleave', handleDragLeave);
    uploadZone?.addEventListener('drop', handlePhotoDrop);
    photoInput?.addEventListener('change', handlePhotoSelect);
    document.getElementById('s3RemovePhoto')?.addEventListener('click', removeUploadedPhoto);

    document.getElementById('s3ApplyTryOn')?.addEventListener('click', applyTryOnLook);
    document.getElementById('s3ShareTryOn')?.addEventListener('click', shareTryOnPreview);
    document.getElementById('s3CreateVideo')?.addEventListener('click', createTryOnVideo);

    document.querySelectorAll('.s3-gallery-item').forEach(item => { item.addEventListener('click', () => selectGalleryDesign(item)); });
    document.getElementById('s3BrowseGallery')?.addEventListener('click', openFullGallery);

    document.querySelectorAll('.s3-main-tab').forEach(tab => { tab.addEventListener('click', () => switchMainMode(tab.dataset.mode)); });

    els.voiceBtn?.addEventListener('click', toggleVoice);

    document.getElementById('s3MyCloset')?.addEventListener('click', openCloset);
    document.getElementById('s3CloseCloset')?.addEventListener('click', closeCloset);
    document.getElementById('s3BecomeCreator')?.addEventListener('click', openBrandBuilder);
    document.getElementById('s3StartCreator')?.addEventListener('click', openBrandBuilder);
    document.getElementById('s3JoinCreators')?.addEventListener('click', openBrandBuilder);
    document.getElementById('s3CloseBrand')?.addEventListener('click', closeBrandBuilder);
    document.getElementById('s3CreateAnother')?.addEventListener('click', createAnother);

    document.getElementById('s3BrandNext1')?.addEventListener('click', () => brandStep(2));
    document.getElementById('s3BrandNext2')?.addEventListener('click', () => brandStep(3));
    document.getElementById('s3BrandNext3')?.addEventListener('click', () => brandStep(4));
    document.getElementById('s3BrandNext4')?.addEventListener('click', () => brandStep(5));
    document.getElementById('s3LaunchBrand')?.addEventListener('click', launchBrand);
    document.getElementById('s3LogoAI')?.addEventListener('click', generateLogo);
    document.getElementById('s3CloseBrandUpsell')?.addEventListener('click', closeBrandUpsell);
    document.getElementById('s3SkipBranding')?.addEventListener('click', skipBranding);
    document.getElementById('s3ContinueBranding')?.addEventListener('click', continueToBranding);

    document.getElementById('s3ClosePackaging')?.addEventListener('click', closePackaging);
    document.getElementById('s3SkipPackaging')?.addEventListener('click', skipPackaging);
    document.getElementById('s3CompleteOrder')?.addEventListener('click', completeOrder);

    ['InsideLabel', 'OutsideLabel', 'HangTag'].forEach(opt => {
      document.getElementById(`s3${opt}Toggle`)?.addEventListener('change', function() {
        toggleBrandingOption(opt.toLowerCase(), this.checked);
      });
    });

    ['CustomBox', 'Tissue', 'Sticker', 'ThankYou'].forEach(opt => {
      document.getElementById(`s3${opt}Toggle`)?.addEventListener('change', function() {
        togglePackagingOption(opt.toLowerCase(), this.checked);
      });
    });
  }
  function selectZone(zone) {
    state.activeZone = zone;

    document.querySelectorAll('.s3-zone-tab').forEach(tab => { tab.classList.toggle('active', tab.dataset.zone === zone); });

    document.querySelectorAll('.s3-product-view').forEach(view => { view.classList.toggle('active', view.dataset.view === zone); });

    els.zoneTag.textContent = CONFIG.ZONES[zone]?.name || zone;
    var av = document.querySelector('.s3-product-view.active');
    if(av){var bi=av.querySelector('.s3-product-base');if(bi){var p=CONFIG.PRODUCTS[state.product],zi=CONFIG.ZONE_IMAGES[state.product]||{};bi.src=zi[zone]||(p?p.img:'')||bi.src;}}
    if (state.designs.has(zone)) {
      els.prompt.value = state.designs.get(zone).prompt || '';
    } else {
      els.prompt.value = '';
    }
    updateCharCount();
  }

  function updateZoneStatus(zone, hasDesign) {
    const tab = document.querySelector(`.s3-zone-tab[data-zone="${zone}"]`);
    if (tab) {
      tab.classList.toggle('has-design', hasDesign);
    }
  }

  function applyDesignToZone(zone, imageUrl) {
    var zid = 's3Design' + zone.split('_').map(function(w){return w.charAt(0).toUpperCase()+w.slice(1)}).join('');
    var designEl = document.getElementById(zid);
    if (designEl) {
      while(designEl.firstChild) designEl.removeChild(designEl.firstChild);
      var img = document.createElement('img');
      img.src = imageUrl; img.alt = 'Design';
      img.style.cssText = 'width:100%;height:100%;object-fit:contain;border-radius:8px;';
      designEl.appendChild(img);
      designEl.classList.add('has-design');
      saveToDesignLibrary(imageUrl, zone);
    }
  }
  function resetZonePlaceholder(zoneEl) {
    while(zoneEl.firstChild) zoneEl.removeChild(zoneEl.firstChild);
    var zoneId = (zoneEl.id||'').replace('s3Design','').replace(/([A-Z])/g,'_$1').toLowerCase().replace(/^_/,'');
    var ph = document.createElement('div');
    ph.className = 's3-zone-placeholder';
    ph.setAttribute('onclick',"openDesignPicker('"+zoneId+"')");
    var t = document.createElement('span');
    t.className = 's3-placeholder-text'; t.textContent = 'Add your design';
    var s = document.createElement('span');
    s.className = 's3-placeholder-sub'; s.textContent = 'Click to upload, drag your file here.';
    ph.appendChild(t); ph.appendChild(s);
    zoneEl.appendChild(ph);
  }
  function getDesignLibrary() {
    try { return JSON.parse(localStorage.getItem('s3_design_library')||'[]'); } catch(e){ return []; }
  }
  function saveToDesignLibrary(url, zone) {
    if(!url) return;
    var lib = getDesignLibrary();
    if(lib.some(function(d){return d.url===url})) return;
    lib.unshift({url:url, zone:zone||'front', ts:Date.now()});
    if(lib.length>50) lib = lib.slice(0,50);
    try { localStorage.setItem('s3_design_library',JSON.stringify(lib)); } catch(e){}
  }
  var _dpZone = 'front';
  function openDesignPicker(zone) {
    _dpZone = zone || 'front';
    var modal = document.getElementById('s3DesignPicker');
    if(!modal){ buildDesignPickerModal(); modal = document.getElementById('s3DesignPicker'); }
    var grid = document.getElementById('s3LibGrid');
    if(grid){
      while(grid.firstChild) grid.removeChild(grid.firstChild);
      var lib = getDesignLibrary();
      if(lib.length===0){
        var empty = document.createElement('p');
        empty.style.cssText='color:rgba(255,255,255,0.4);text-align:center;grid-column:1/-1;padding:20px 0;font-size:12px;';
        empty.textContent='No saved designs yet. Generate or upload your first design!';
        grid.appendChild(empty);
      } else {
        lib.forEach(function(d){
          var item = document.createElement('div');
          item.style.cssText='border-radius:8px;overflow:hidden;cursor:pointer;border:2px solid transparent;aspect-ratio:1;';
          item.addEventListener('mouseenter',function(){this.style.borderColor='#ec4899'});
          item.addEventListener('mouseleave',function(){this.style.borderColor='transparent'});
          var im = document.createElement('img');
          im.src=d.url; im.alt='Design'; im.style.cssText='width:100%;height:100%;object-fit:cover;';
          item.appendChild(im);
          item.addEventListener('click',function(){
            selectZone(_dpZone);
            applyDesignToZone(_dpZone,d.url);
            state.designs.set(_dpZone,{url:d.url,zone:_dpZone});
            updateZoneStatus(_dpZone,true);
            closeDesignPicker();
          });
          grid.appendChild(item);
        });
      }
    }
    modal.style.display='flex';
  }
  function closeDesignPicker(){
    var m=document.getElementById('s3DesignPicker');
    if(m) m.style.display='none';
  }
  window.openDesignPicker = openDesignPicker;
  window.closeDesignPicker = closeDesignPicker;
  function s3Sb(p){
    var map={upload:'browse',create:'create',designs:'browse',tryon:'tryon'};
    var mode=map[p];
    if(!mode){lucySay(p==='layers'?'Layers panel coming soon! 🔜':'Need help? Visit our FAQ or contact support 💬');return;}
    switchMainMode(mode);
    document.querySelectorAll('.s3-sb').forEach(function(b){b.classList.remove('active')});
    if(event&&event.currentTarget)event.currentTarget.classList.add('active');
  }
  window.s3Sb=s3Sb;
  function buildDesignPickerModal(){
    var m=document.createElement('div');
    m.id='s3DesignPicker';
    m.style.cssText='display:none;position:fixed;inset:0;z-index:10001;background:rgba(0,0,0,0.8);align-items:center;justify-content:center;backdrop-filter:blur(4px);';
    m.addEventListener('click',function(e){if(e.target===m)closeDesignPicker()});
    var box=document.createElement('div');
    box.style.cssText='background:#1a1a2e;border-radius:16px;padding:24px;max-width:480px;width:90%;max-height:80vh;overflow-y:auto;';
    var hdr=document.createElement('div');
    hdr.style.cssText='display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;';
    var title=document.createElement('h3');
    title.style.cssText='color:#fff;font-size:16px;margin:0;';
    title.textContent='Add Design';
    var closeBtn=document.createElement('button');
    closeBtn.style.cssText='background:none;border:none;color:#fff;font-size:20px;cursor:pointer;';
    closeBtn.textContent='\u00D7';
    closeBtn.addEventListener('click',closeDesignPicker);
    hdr.appendChild(title); hdr.appendChild(closeBtn);
    var acts=document.createElement('div');
    acts.style.cssText='display:flex;gap:8px;margin-bottom:20px;';
    var uploadBtn=document.createElement('button');
    uploadBtn.style.cssText='flex:1;padding:12px;border-radius:10px;border:1.5px dashed rgba(255,255,255,0.3);background:rgba(255,255,255,0.05);color:#fff;cursor:pointer;font-size:13px;font-weight:600;';
    uploadBtn.textContent='\u2B06 Upload Image';
    uploadBtn.addEventListener('click',function(){
      var fi=document.getElementById('s3FileInput');
      if(!fi){fi=document.createElement('input');fi.type='file';fi.id='s3FileInput';fi.accept='image/*';fi.style.display='none';
        fi.addEventListener('change',handleFileUpload);document.body.appendChild(fi);}
      fi.click();
    });
    var aiBtn=document.createElement('button');
    aiBtn.style.cssText='flex:1;padding:12px;border-radius:10px;border:1.5px solid rgba(236,72,153,0.4);background:rgba(236,72,153,0.15);color:#fff;cursor:pointer;font-size:13px;font-weight:600;';
    aiBtn.textContent='\u2728 AI Generate';
    aiBtn.addEventListener('click',function(){
      closeDesignPicker();
      selectZone(_dpZone);
      var pi=document.getElementById('s3PromptInput');
      if(pi) pi.focus();
    });
    acts.appendChild(uploadBtn); acts.appendChild(aiBtn);
    var libLabel=document.createElement('div');
    libLabel.style.cssText='color:rgba(255,255,255,0.5);font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px;';
    libLabel.textContent='Your Design Library';
    var grid=document.createElement('div');
    grid.id='s3LibGrid';
    grid.style.cssText='display:grid;grid-template-columns:repeat(3,1fr);gap:8px;';
    box.appendChild(hdr); box.appendChild(acts); box.appendChild(libLabel); box.appendChild(grid);
    m.appendChild(box); document.body.appendChild(m);
  }
  function handleFileUpload(e){
    var file=e.target.files&&e.target.files[0];
    if(!file) return;
    if(!file.type.startsWith('image/')){lucySay('Please upload an image file.');return;}
    if(file.size>10*1024*1024){lucySay('Image must be under 10MB.');return;}
    var fd=new FormData(); fd.append('file',file);
    lucySay('Uploading your design...');
    closeDesignPicker();
    fetch(API_BASE+'/api/design/upload',{method:'POST',body:fd})
    .then(function(r){return r.json()})
    .then(function(data){
      if(data.url){
        selectZone(_dpZone);
        applyDesignToZone(_dpZone,data.url);
        state.designs.set(_dpZone,{url:data.url,zone:_dpZone});
        updateZoneStatus(_dpZone,true);
        lucySay('Design applied to '+(_dpZone.replace(/_/g,' '))+' zone!');
      } else { lucySay('Upload failed. Try again or use AI Generate.'); }
    })
    .catch(function(){lucySay('Upload failed. Try again or use AI Generate.')});
    e.target.value='';
  }
  let apiRetryCount = 0;
  const MAX_RETRIES = 2;
  const RETRY_DELAY = 2000;

  function updateApiStatus(status, text) {
    const indicator = document.getElementById('s3ApiStatus');
    if (!indicator) return;

    indicator.classList.remove('degraded', 'error');
    if (status === 'degraded') indicator.classList.add('degraded');
    if (status === 'error') indicator.classList.add('error');

    const textEl = indicator.querySelector('.s3-api-text');
    if (textEl) textEl.textContent = text;
  }

  const PRODUCT_SLUG_MAP = {
    tshirt: 't-shirt', hoodie: 'hoodie', sweatshirt: 'sweatshirt', longsleeve: 'longsleeve',
    tank: 'tank-top', croptop: 'crop-top', phonecase: 'phone-case', totebag: 'tote-bag',
    hat: 'hat', beanie: 'beanie', mug: 'mug', poster: 'fine-art-poster',
    canvas: 'canvas', pillow: 'pillow', blanket: 'blanket',
    babyonesie: 'baby-onesie', kidstee: 'kids-tee'
  };
  const PRINT_METHOD_ICONS = { dtg: '🖨️', dtf: '📋', embroidery: '🧵' };

  function loadS3PrintMethods(productKey) {
    var slug = PRODUCT_SLUG_MAP[productKey] || productKey;
    fetch(CONFIG.API_BASE + '/api/pod/print-methods/' + encodeURIComponent(slug))
      .then(function(r) { return r.json(); })
      .then(function(data) {
        state.printMethods = data.methods || ['dtg'];
        state.printMethodDetails = data.details || [];
        if (state.printMethods.indexOf(state.printMethod) === -1) {
          state.printMethod = state.printMethods[0] || 'dtg';
        }
        renderS3PrintPills();
      })
      .catch(function() {
        state.printMethods = ['dtg'];
        state.printMethodDetails = [];
        state.printMethod = 'dtg';
        renderS3PrintPills();
      });
  }

  function renderS3PrintPills() {
    var container = document.getElementById('s3PrintPills');
    var card = document.getElementById('s3PrintMethodCard');
    if (!container) return;
    while (container.firstChild) container.removeChild(container.firstChild);
    if (state.printMethods.length <= 1) {
      if (card) card.style.display = 'none';
      return;
    }
    if (card) card.style.display = '';
    var names = { dtg: 'DTG', dtf: 'DTF', embroidery: 'EMB' };
    state.printMethods.forEach(function(method) {
      var pill = document.createElement('div');
      pill.className = 's3-print-pill' + (method === state.printMethod ? ' active' : '');
      pill.setAttribute('data-method', method);
      var icon = document.createElement('span');
      icon.textContent = (PRINT_METHOD_ICONS[method] || '🖨️') + ' ';
      pill.appendChild(icon);
      pill.appendChild(document.createTextNode(names[method] || method.toUpperCase()));
      pill.addEventListener('click', function() { selectS3PrintMethod(method); });
      container.appendChild(pill);
    });
  }

  function selectS3PrintMethod(method) {
    state.printMethod = method;
    renderS3PrintPills();
    if (method === 'embroidery') {
      lucySay('Embroidery mode! I\'ll create bold, simple patch designs with max 6 colors — perfect for stitching. 🧵');
    } else if (method === 'dtf') {
      lucySay('DTF mode! Vibrant colors on any fabric color — great for dark garments. 📋');
    } else {
      lucySay('DTG mode! Full-color detailed designs — the classic choice. 🖨️');
    }
  }

  async function generateDesign() {
    const prompt = els.prompt.value.trim();
    if (!prompt || prompt.length < 3) {
      lucySay("Tell me more about your vision! Even a few words help me create something amazing.");
      return;
    }

    if (state.credits <= 0) {
      lucySay("You're out of credits! Buy more to keep creating, or your free credits reset tomorrow at midnight.");
      return;
    }

    if (state.generating) return;

    state.generating = true;
    showGenerating();
    updateApiStatus('ok', 'Generating...');

    var creditSpent = await spendCreditOnServer();
    if (!creditSpent) {
      lucySay("Could not verify credits. Please try again!");
      state.generating = false;
      hideGenerating();
      return;
    }

    let lastError = null;

    for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
      try {
        if (attempt > 0) {
          updateApiStatus('degraded', `Retrying (${attempt}/${MAX_RETRIES})...`);
          lucySay(`Just a moment... giving it another try!`);
          await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
        }

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 30000);

        const response = await fetch(`${CONFIG.API_BASE}/api/design/generate`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          signal: controller.signal,
          body: JSON.stringify({
            prompt: prompt,
            style: state.style,
            product_type: state.product,
            zone: state.activeZone,
            provider: state.model,
            print_method: state.printMethod || 'dtg'
          })
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error(`Server error: ${response.status}`);
        }

        const data = await response.json();

        if (data.success && (data.designs?.[0] || data.design_url)) {
          const design = data.designs?.[0] || { url: data.design_url, id: data.design_id || Date.now().toString() };

          state.designs.set(state.activeZone, {
            url: design.url,
            prompt: prompt,
            style: state.style,
            id: design.id
          });

          applyDesignToZone(state.activeZone, design.url);
          updateZoneStatus(state.activeZone, true);
          updateOrderItems();
          updatePrice();

          apiRetryCount = 0;
          updateApiStatus('ok', 'AI Ready');

          const cheers = [
            "Stunning! Your design is ready!",
            "Love it! That looks incredible!",
            "Perfect! Want to add another zone?",
            "Amazing work! This is going to be a hit!"
          ];
          lucySay(cheers[Math.floor(Math.random() * cheers.length)]);

          if (state.designs.size === 1 && !state.shownPostGenUpsell) {
            state.shownPostGenUpsell = true;
            setTimeout(() => {
              showPostGenerationUpsell();
            }, 2500);
          }

          state.generating = false;
          hideGenerating();
          return;

        } else {
          throw new Error(data.error || 'Generation failed');
        }

      } catch (error) {
        lastError = error;

        if (error.name === 'AbortError') {
          lastError = new Error('Request timed out');
        }
      }
    }

    apiRetryCount++;

    fetchCreditsFromServer();

    if (apiRetryCount >= 3) {
      updateApiStatus('error', 'AI Unavailable');
      lucySay("The AI service seems to be having issues. Please try again in a few minutes, or try a different AI model.");
    } else {
      updateApiStatus('degraded', 'AI Busy');
      lucySay("Oops! The AI is taking a breather. Let's try again - sometimes it just needs a moment!");
    }

    state.generating = false;
    hideGenerating();
  }

  async function checkApiHealth() {
    try {
      const response = await fetch(`${CONFIG.API_BASE}/api/health`, {
        method: 'GET',
        timeout: 5000
      });

      if (response.ok) {
        updateApiStatus('ok', 'AI Ready');
      } else {
        updateApiStatus('degraded', 'AI Slow');
      }
    } catch (error) {
      updateApiStatus('error', 'AI Offline');
      lucySay("Heads up - the AI might be slow right now. Your designs will still work, just may take a moment longer!");
    }
  }

  async function enhancePrompt() {
    const current = els.prompt.value.trim();
    if (!current) {
      lucySay("Type something first, then I'll make it even better!");
      return;
    }

    lucySay("Let me enhance that for you...");

    const enhancements = [
      ', highly detailed, professional quality, vibrant colors',
      ', artistic composition, stunning visual, trending style',
      ', intricate details, beautiful lighting, premium design',
      ', masterpiece quality, sharp focus, elegant composition'
    ];

    els.prompt.value = current + enhancements[Math.floor(Math.random() * enhancements.length)];
    updateCharCount();
    lucySay("Enhanced! Your prompt is now more detailed.");
  }

  function randomPrompt() {
    const prompts = [
      "A cosmic wolf howling at a geometric moon with aurora borealis",
      "Vintage botanical illustration with butterflies and sacred geometry",
      "Abstract neon waves on dark background with holographic effects",
      "Minimalist mountain landscape at golden hour with reflection",
      "Retro 80s synthwave cityscape with palm trees and sunset",
      "Japanese wave art style with modern geometric patterns",
      "Ethereal forest spirit with bioluminescent elements",
      "Steampunk mechanical heart with gears and roses",
      "Cosmic astronaut floating in a sea of flowers",
      "Tribal mandala with nature elements and animals"
    ];

    els.prompt.value = prompts[Math.floor(Math.random() * prompts.length)];
    updateCharCount();
    lucySay("Here's an idea! Edit it if you like, then hit Generate!");
  }
  function updatePrice() {
    const basePrice = CONFIG.PRODUCTS[state.product].price;
    let zonePrice = 0;

    state.designs.forEach((design, zone) => {
      if (CONFIG.ZONES[zone] && zone !== 'front') {
        zonePrice += CONFIG.ZONES[zone].price;
      }
    });

    const subtotal = (basePrice + zonePrice) * state.quantity;
    const virtueAmount = subtotal * CONFIG.VIRTUE_PERCENTAGE;

    els.totalPrice.textContent = `€${subtotal.toFixed(2)}`;
    els.virtueAmount.textContent = `€${virtueAmount.toFixed(2)}`;
    els.impactAmount.textContent = `€${virtueAmount.toFixed(2)}`;
  }

  function updateOrderItems() {
    let html = `
      <div class="s3-order-item">
        <span class="s3-item-name">${CONFIG.PRODUCTS[state.product].name} (Base)</span>
        <span class="s3-item-price">€${CONFIG.PRODUCTS[state.product].price.toFixed(2)}</span>
      </div>
    `;

    state.designs.forEach((design, zone) => {
      if (CONFIG.ZONES[zone] && CONFIG.ZONES[zone].price > 0) {
        html += `
          <div class="s3-order-item">
            <span class="s3-item-name">${CONFIG.ZONES[zone].name} Design</span>
            <span class="s3-item-price">+€${CONFIG.ZONES[zone].price.toFixed(2)}</span>
          </div>
        `;
      }
    });

    els.orderItems.innerHTML = html;
  }

  function updateSizes() {
    const sizes = CONFIG.PRODUCTS[state.product].sizes;
    const container = document.getElementById('s3Sizes');

    container.innerHTML = sizes.map(size => `
      <button class="s3-size ${size === state.size ? 'active' : ''}" data-size="${size}">${size}</button>
    `).join('');

    container.querySelectorAll('.s3-size').forEach(btn => {
      btn.addEventListener('click', function() {
        container.querySelectorAll('.s3-size').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        state.size = this.dataset.size;
      });
    });

    if (!sizes.includes(state.size)) {
      state.size = sizes[Math.floor(sizes.length / 2)];
    }
  }
  async function addToCart() {
    if (state.designs.size === 0) {
      lucySay("You haven't created any designs yet! Let's make something first.");
      return;
    }

    const product = CONFIG.PRODUCTS[state.product];
    const supportsBranding = product && product.category === 'apparel';

    if (supportsBranding && state.currentTier === 1 && !state.branding.enabled) {
      showBrandUpsell();
      return;
    }

    proceedToCart();
  }

  function saveToCloset() {
    if (state.designs.size === 0) {
      lucySay("Create a design first, then save it to your closet!");
      return;
    }

    const item = {
      id: Date.now(),
      product: state.product,
      color: state.color,
      size: state.size,
      designs: Object.fromEntries(state.designs),
      createdAt: new Date().toISOString()
    };

    state.closet.push(item);
    localStorage.setItem('s3_closet', JSON.stringify(state.closet));

    lucySay("Saved to your closet! You can order it anytime.");
    updateClosetCount();
  }

  function openCloset() {
    renderCloset();
    els.closetModal.classList.add('active');
  }

  function closeCloset() {
    els.closetModal.classList.remove('active');
  }
  let selectedAvatar = null;
  let uploadedPhoto = null;

  function openTryOnModal() {
    els.tryOnModal?.classList.add('active');
    selectedAvatar = null;
    uploadedPhoto = null;
    els.tryOnPreview.style.display = 'none';
    document.querySelectorAll('.s3-avatar-item').forEach(item => item.classList.remove('selected'));
  }

  function closeTryOnModal() { els.tryOnModal?.classList.remove('active'); }

  function switchTryOnTab(tab) {
    document.querySelectorAll('.s3-tryon-tab').forEach(t => { t.classList.toggle('active', t.dataset.tab === tab); });
    document.getElementById('s3TryOnAvatars').classList.toggle('active', tab === 'avatars');
    document.getElementById('s3TryOnUpload').classList.toggle('active', tab === 'upload');
  }

  function selectAvatar(item) {
    document.querySelectorAll('.s3-avatar-item').forEach(i => i.classList.remove('selected'));
    item.classList.add('selected');
    selectedAvatar = item.querySelector('img').src;
    showTryOnPreview(selectedAvatar);
  }

  function handleDragOver(e) { e.preventDefault(); e.currentTarget.classList.add('dragover'); }

  function handleDragLeave(e) {
    e.currentTarget.classList.remove('dragover');
  }

  function handlePhotoDrop(e) {
    e.preventDefault();
    e.currentTarget.classList.remove('dragover');
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      processUploadedPhoto(file);
    }
  }

  function handlePhotoSelect(e) {
    const file = e.target.files[0];
    if (file) {
      processUploadedPhoto(file);
    }
  }

  function processUploadedPhoto(file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      uploadedPhoto = e.target.result;
      const preview = document.getElementById('s3UploadPreview');
      const uploadZone = document.getElementById('s3PhotoUploadZone');
      document.getElementById('s3UploadedPhoto').src = uploadedPhoto;
      uploadZone.style.display = 'none';
      preview.style.display = 'block';
      showTryOnPreview(uploadedPhoto);
    };
    reader.readAsDataURL(file);
  }

  function removeUploadedPhoto() {
    uploadedPhoto = null;
    document.getElementById('s3UploadPreview').style.display = 'none';
    document.getElementById('s3PhotoUploadZone').style.display = 'block';
    els.tryOnPreview.style.display = 'none';
  }

  function showTryOnPreview(avatarSrc) {
    const currentDesign = state.designs.get(state.activeZone);
    const designUrl = currentDesign?.url || '';

    els.previewAvatar.src = avatarSrc;
    els.previewDesign.src = designUrl;
    els.previewDesign.style.display = designUrl ? 'block' : 'none';
    els.tryOnPreview.style.display = 'flex';
  }

  function applyTryOnLook() {
    lucySay('Awesome choice! Your design looks amazing on this style! 🌟');
    closeTryOnModal();
  }

  function shareTryOnPreview() {
    var dd = document.getElementById('s3ShareDropdown');
    dd.classList.toggle('open');
  }

  document.addEventListener('click', function(e) {
    var dd = document.getElementById('s3ShareDropdown');
    if (dd && !e.target.closest('.s3-tryon-share-wrap')) dd.classList.remove('open');
  });

  document.querySelectorAll('.s3-share-opt').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var platform = this.dataset.platform;
      document.getElementById('s3ShareDropdown').classList.remove('open');
      if (platform === 'copy') {
        navigator.clipboard.writeText(window.location.href);
        lucySay('Share link copied to clipboard! 📋');
        return;
      }
      shareToSocial(platform);
    });
  });

  async function shareToSocial(platform) {
    var designData = state.designs.get(state.activeZone);
    var imageUrl = designData ? designData.url : null;
    if (!imageUrl) { lucySay('Generate a design first before sharing! 🎨'); return; }

    lucySay('Sharing your look to ' + platform + '... 📤');
    try {
      var resp = await fetch(CONFIG.API_BASE + '/api/share/look', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          image_url: imageUrl,
          caption: 'Check out this custom design I created with AI on WowStore! ✨🛍️ #WowStore #AIFashion #CustomDesign',
          platforms: [platform],
          browser_id: getBrowserId()
        })
      });
      var data = await resp.json();
      if (data.status === 'completed') {
        var pr = data.results && data.results[platform];
        if (pr && pr.intent_url) {
          window.open(pr.intent_url, '_blank', 'noopener,noreferrer,width=640,height=720');
          lucySay('Opened ' + platform + ' in a new window — finalize the post there! 🎉');
        } else if (pr && pr.method === 'unsupported') {
          lucySay(platform + ' needs a connected account (coming soon). Try Twitter, Facebook, or Pinterest for now! 🔄');
        } else {
          lucySay('Your look was shared to ' + platform + '! 🎉🔥');
        }
      } else {
        lucySay('Sharing failed: ' + (data.error || 'Unknown error') + ' 😔');
      }
    } catch(err) {
      lucySay('Could not share right now. Try again later! 🔄');
    }
  }

  async function createTryOnVideo() {
    var videoBtn = document.getElementById('s3CreateVideo');
    var designData = state.designs.get(state.activeZone);
    var productImg = designData ? designData.url : null;
    var avatarImg = selectedAvatar || uploadedPhoto || null;
    if (!productImg) { lucySay('Generate a design first! 🎨'); return; }

    videoBtn.disabled = true;
    videoBtn.textContent = '⏳ Creating Video...';
    lucySay('Creating your Magic Mirror video... This takes about 30 seconds! 🎬');

    try {
      var resp = await fetch(CONFIG.API_BASE + '/api/lucy/video/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_image_url: productImg,
          tryon_image_url: avatarImg || productImg,
          product_name: state.selectedProduct || 'Custom Design',
          price: '',
          browser_id: getBrowserId()
        })
      });
      var data = await resp.json();
      if (data.status === 'completed' && data.public_url) {
        lucySay('Your video is ready! 🎬🔥');
        showVideoPlayer(data.public_url);
      } else if (data.error && data.error.indexOf('insufficient') !== -1) {
        lucySay('Not enough tokens for video! Videos cost 5 tokens. 💎');
      } else {
        lucySay('Video creation failed: ' + (data.error || 'Unknown error'));
      }
    } catch(err) {
      lucySay('Video creation failed. Try again! 🔄');
    } finally {
      videoBtn.disabled = false;
      videoBtn.textContent = '🎬 Create Video';
    }
  }

  function showVideoPlayer(videoUrl) {
    var overlay = document.getElementById('s3VideoOverlay');
    var videoEl = document.getElementById('s3VideoEl');
    var dlLink = document.getElementById('s3VideoDl');
    overlay.style.display = 'flex';
    videoEl.src = videoUrl;
    dlLink.href = videoUrl;
    videoEl.play();
  }

  document.getElementById('s3VideoClose')?.addEventListener('click', function() {
    var overlay = document.getElementById('s3VideoOverlay');
    var videoEl = document.getElementById('s3VideoEl');
    videoEl.pause(); videoEl.src = '';
    overlay.style.display = 'none';
  });

  document.getElementById('s3VideoShareBtn')?.addEventListener('click', function() {
    var videoUrl = document.getElementById('s3VideoEl').src;
    if (videoUrl) shareToSocial('instagram');
  });
  function selectGalleryDesign(item) {
    const designId = item.dataset.design;
    const designImg = item.querySelector('img')?.src;

    document.querySelectorAll('.s3-gallery-item').forEach(i => i.classList.remove('selected'));
    item.classList.add('selected');

    if (designImg) {
      applyDesignToZone(state.activeZone, designImg);
      state.designs.set(state.activeZone, {
        url: designImg,
        prompt: `Gallery design: ${designId}`,
        zone: state.activeZone
      });
      updateZoneStatus(state.activeZone, true);
      lucySay(`Beautiful pick! The ${designId} design is now applied. You can customize it further or add to cart! ✨`);
    }
  }

  function openFullGallery() {
    lucySay('Full design gallery coming soon! For now, try these featured designs or create your own with AI! 🎨');
  }

  function loadClosetToGallery() {
    const galleryGrid = document.getElementById('s3GalleryGrid');
    if (!galleryGrid || state.closet.length === 0) return;

    const closetDesigns = state.closet.map(item => {
      const firstDesign = Object.values(item.designs)[0];
      if (!firstDesign?.url) return '';
      return `
        <div class="s3-gallery-item s3-closet-design" data-design="closet-${item.id}" data-closet-id="${item.id}">
          <img src="${firstDesign.url}" alt="My Design">
          <span class="s3-gallery-badge">💾 Saved</span>
        </div>
      `;
    }).filter(Boolean).join('');

    if (closetDesigns) {
      galleryGrid.insertAdjacentHTML('afterbegin', closetDesigns);
      document.querySelectorAll('.s3-closet-design').forEach(item => { item.addEventListener('click', () => selectGalleryDesign(item)); });
    }
  }
  function switchMainMode(mode) {
    document.querySelectorAll('.s3-main-tab').forEach(tab => { tab.classList.toggle('active', tab.dataset.mode === mode); });

    switch(mode) {
      case 'create':
        lucySay('Let\'s create something amazing! Describe your vision or use AI to enhance your ideas. ✨');
        break;
      case 'browse':
        const galleryCard = document.querySelector('.s3-gallery-card');
        if (galleryCard) {
          galleryCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
          galleryCard.classList.add('highlighted');
          setTimeout(() => galleryCard.classList.remove('highlighted'), 2000);
        }
        lucySay('Browse designs from our community! Tap any design to apply it instantly. 🎨');
        break;
      case 'tryon':
        openTryOnModal();
        break;
    }
  }

  function renderCloset() {
    if (state.closet.length === 0) {
      document.getElementById('s3ClosetEmpty').style.display = 'block';
      return;
    }

    document.getElementById('s3ClosetEmpty').style.display = 'none';

    els.closetGrid.innerHTML = state.closet.map(item => {
      const firstDesign = Object.values(item.designs)[0];
      return `
        <div class="s3-closet-item" data-id="${item.id}">
          <img src="${firstDesign?.url || ''}" alt="Design">
          <div class="s3-closet-item-info">
            <span>${CONFIG.PRODUCTS[item.product]?.name || item.product}</span>
            <span>Size: ${item.size}</span>
          </div>
        </div>
      `;
    }).join('');

    updateClosetCount();
  }

  function updateClosetCount() {
    els.closetCount.textContent = state.closet.length;
  }

  function calculateTotal() {
    const basePrice = CONFIG.PRODUCTS[state.product].price;
    let zonePrice = 0;
    state.designs.forEach((design, zone) => {
      if (CONFIG.ZONES[zone] && zone !== 'front') {
        zonePrice += CONFIG.ZONES[zone].price;
      }
    });
    return (basePrice + zonePrice) * state.quantity;
  }

  function getVariantId() {
    const variants = {
      tshirt: window.__S3.variants.tshirt || window.__S3.variants.tshirt,
      hoodie: window.__S3.variants.hoodie || window.__S3.variants.tshirt,
      sweatshirt: window.__S3.variants.sweatshirt || window.__S3.variants.tshirt,
      longsleeve: window.__S3.variants.longsleeve || window.__S3.variants.tshirt,
      tank: window.__S3.variants.tank || window.__S3.variants.tshirt
    };
    return variants[state.product] || variants.tshirt;
  }
  function lucyGreet() {
    const greeting = CONFIG.LUCY_GREETINGS[Math.floor(Math.random() * CONFIG.LUCY_GREETINGS.length)];
    lucySay(greeting);
    initLucyProactiveTips();
  }
  let lucyIdleTimer = null;
  let lucyTipIndex = 0;
  const LUCY_IDLE_DELAY = 30000;

  function initLucyProactiveTips() {
    resetLucyIdleTimer();

    ['click', 'keydown', 'scroll', 'touchstart'].forEach(event => {
      document.addEventListener(event, resetLucyIdleTimer, { passive: true });
    });
  }

  function resetLucyIdleTimer() {
    if (lucyIdleTimer) clearTimeout(lucyIdleTimer);
    lucyIdleTimer = setTimeout(showLucyProactiveTip, LUCY_IDLE_DELAY);
  }

  function showLucyProactiveTip() {
    if (state.generating || state.lucySpeaking) {
      resetLucyIdleTimer();
      return;
    }

    const contextualTips = getContextualTips();
    if (contextualTips.length > 0) {
      const tip = contextualTips[lucyTipIndex % contextualTips.length];
      lucySay(tip);
      lucyTipIndex++;
    }

    lucyIdleTimer = setTimeout(showLucyProactiveTip, LUCY_IDLE_DELAY * 2);
  }

  function getContextualTips() {
    const tips = [];

    if (state.designs.size === 0) {
      tips.push(
        "💡 Tip: Try describing emotions or vibes, like 'peaceful sunset' or 'energetic abstract'!",
        "🎨 Feeling stuck? Hit the '🎲 Inspire' button for random creative prompts!",
        "✨ Pro tip: The more specific your description, the better the result. Add colors, styles, moods!"
      );
    }

    if (state.designs.size === 1 && state.activeZone === 'front') {
      tips.push(
        "🔙 Your front looks great! Try adding a back design to make it even more unique!",
        "💪 Sleeve prints are trending! Add a small logo or symbol to the sleeves.",
        "🏷️ Want to build a brand? Add a custom label for that professional touch!"
      );
    }

    if (!state.lucyListening) {
      tips.push(
        "🎙️ Did you know you can talk to me? Click 'Talk to Lucy' and describe your vision!"
      );
    }

    if (state.designs.size >= 2 && state.currentTier === 1) {
      tips.push(
        "✨ Your designs are amazing! Consider adding custom branding to make it officially yours.",
        "🚀 Ready to start selling? The 'Become Creator' button unlocks your own storefront!"
      );
    }

    if (!state.generating && state.designs.size > 0) {
      tips.push(
        "👕 This design would look great on a hoodie too! Try switching products.",
        "🎁 Phone cases and mugs make great gifts! Check out the Accessories tab."
      );
    }

    return tips;
  }

  function lucySay(message) {
    var msgDiv = document.createElement('div');
    msgDiv.className = 's3-lucy-message';
    var msgP = document.createElement('p');
    msgP.textContent = message;
    msgDiv.appendChild(msgP);
    clearChildren(els.lucyChat);
    els.lucyChat.appendChild(msgDiv);

    if (!state.lucySpeaking) {
      state.lucySpeaking = true;
      els.lucyWave.classList.add('active');
      els.lucyStatus.textContent = 'Speaking...';

      var lucySafetyTimeout = setTimeout(function() {
        if (state.lucySpeaking) {
          state.lucySpeaking = false;
          els.lucyWave.classList.remove('active');
          els.lucyStatus.textContent = 'Ready to create';
        }
      }, 15000);

      lucySpeakWithChatterbox(message)
        .then(function() { clearTimeout(lucySafetyTimeout); })
        .catch(() => {
          lucySpeakFallback(message);
          setTimeout(function() { clearTimeout(lucySafetyTimeout); }, 200);
        });
    }
  }

  async function lucySpeakWithChatterbox(message) {
    try {

      const response = await fetch('https://ai-api.wowstore.live/tts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          text: message,
          persona: 'lucy',
          exaggeration: 0.85,
          cfg_weight: 0.15
        })
      });

      if (response.ok) {
        const audioBlob = await response.blob();
        const audioUrl = URL.createObjectURL(audioBlob);

        return new Promise((resolve, reject) => {
          const audio = new Audio(audioUrl);

          audio.onended = () => {
            state.lucySpeaking = false;
            els.lucyWave.classList.remove('active');
            els.lucyStatus.textContent = 'Ready to create';
            URL.revokeObjectURL(audioUrl);
            resolve();
          };

          audio.onerror = (err) => {
            reject(err);
          };

          audio.play().catch(reject);
        });
      } else {
        throw new Error('Chatterbox response not OK');
      }
    } catch (error) {
      throw error;
    }
  }

  function lucySpeakFallback(message) {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(message);

      const voices = speechSynthesis.getVoices();
      const femaleVoice = voices.find(v =>
        v.name.includes('Samantha') || v.name.includes('Karen') ||
        v.name.includes('Female') || v.name.includes('Fiona')
      ) || voices.find(v => v.lang.startsWith('en')) || voices[0];

      if (femaleVoice) utterance.voice = femaleVoice;
      utterance.rate = 0.95;
      utterance.pitch = 1.1;

      utterance.onend = () => {
        state.lucySpeaking = false;
        els.lucyWave.classList.remove('active');
        els.lucyStatus.textContent = 'Ready to create';
      };

      speechSynthesis.speak(utterance);
    } else {
      state.lucySpeaking = false;
      els.lucyWave.classList.remove('active');
      els.lucyStatus.textContent = 'Ready to create';
    }
  }

  function toggleVoice() {
    if (!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) {
      lucySay("Voice input isn't supported in your browser. Try typing instead!");
      return;
    }

    if (state.lucyListening) {
      stopListening();
    } else {
      startListening();
    }
  }

  function startListening() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();

    recognition.continuous = false;
    recognition.interimResults = true;
    recognition.lang = 'en-GB';

    recognition.onstart = () => {
      state.lucyListening = true;
      els.voiceBtn.classList.add('listening');
      els.lucyWave.classList.add('active');
      els.lucyStatus.textContent = 'Listening...';
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      processVoice(transcript);
    };

    recognition.onend = stopListening;
    recognition.onerror = (event) => {
      stopListening();
      if (event.error === 'no-speech') {
        lucySay("Hi there! Just say what you'd like to create, like 'a cosmic wolf design' or 'switch to back view'.");
      } else if (event.error === 'audio-capture') {
        lucySay("I can't access your microphone. Please check your browser permissions and try again.");
      } else if (event.error === 'not-allowed') {
        lucySay("Microphone access was denied. Please allow microphone access to talk to me!");
      } else {
        lucySay("Hmm, I missed that. Try speaking a bit closer to your microphone!");
      }
    };

    recognition.start();
  }

  function stopListening() {
    state.lucyListening = false;
    els.voiceBtn.classList.remove('listening');
    els.lucyWave.classList.remove('active');
    els.lucyStatus.textContent = 'Ready to create';
  }

  function processVoice(transcript) {
    const lower = transcript.toLowerCase();

    if (lower.includes('generate') || lower.includes('create')) {
      const prompt = transcript.replace(/generate|create|a design of|a design with/gi, '').trim();
      if (prompt) {
        els.prompt.value = prompt;
        updateCharCount();
        generateDesign();
      }
    } else if (lower.includes('back')) {
      selectZone('back');
      lucySay("Switched to back view!");
    } else if (lower.includes('front')) {
      selectZone('front');
      lucySay("Switched to front view!");
    } else if (lower.includes('add to cart') || lower.includes('buy')) {
      addToCart();
    } else if (lower.includes('price') || lower.includes('total')) {
      lucySay(`Your current total is ${els.totalPrice.textContent}. 5% goes to the cause you choose!`);
    } else {
      els.prompt.value = transcript;
      updateCharCount();
      lucySay(`Got it! "${transcript}" - tap Generate when you're ready!`);
    }
  }
  function openBrandBuilder() {
    state.brandStep = 1;
    updateBrandStep();
    els.brandModal.classList.add('active');
  }

  function closeBrandBuilder() {
    els.brandModal.classList.remove('active');
  }

  function brandStep(step) {
    if (step === 2) {
      state.brand.name = document.getElementById('s3BrandName').value.trim();
      state.brand.tagline = document.getElementById('s3BrandTagline').value.trim();
      if (!state.brand.name) {
        lucySay("Please enter your brand name first!");
        return;
      }
    }

    state.brandStep = step;
    updateBrandStep();
  }

  function updateBrandStep() {
    document.querySelectorAll('.s3-bp-step').forEach(s => {
      const num = parseInt(s.dataset.step);
      s.classList.remove('active', 'completed');
      if (num === state.brandStep) s.classList.add('active');
      if (num < state.brandStep) s.classList.add('completed');
    });

    document.querySelectorAll('.s3-brand-step').forEach(s => { s.classList.toggle('active', parseInt(s.dataset.step) === state.brandStep); });

    if (state.brandStep === 5) {
      renderBrandPreview();
    }
  }

  function generateLogo() {
    const preview = document.getElementById('s3LogoPreview');
    const initial = escapeHTML(state.brand.name.charAt(0).toUpperCase());
    clearChildren(preview);
    var logoBox = document.createElement('div');
    logoBox.style.cssText = 'width:80px;height:80px;background:linear-gradient(135deg,#EC4899,#8B5CF6);border-radius:20px;display:flex;align-items:center;justify-content:center;font-size:32px;color:white;font-weight:bold;margin:20px auto;';
    logoBox.textContent = initial;
    var logoMsg = document.createElement('p');
    logoMsg.style.cssText = 'text-align:center;font-size:12px;color:#666;';
    logoMsg.textContent = 'AI-generated logo ready!';
    preview.appendChild(logoBox);
    preview.appendChild(logoMsg);

    lucySay("Logo created! Looking good!");
  }

  function renderBrandPreview() {
    const preview = document.getElementById('s3BrandPreview');
    const primary = document.getElementById('s3BrandPrimary').value.replace(/[^#a-fA-F0-9]/g, '');
    const secondary = document.getElementById('s3BrandSecondary').value.replace(/[^#a-fA-F0-9]/g, '');
    clearChildren(preview);
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'background:linear-gradient(135deg,' + primary + ',' + secondary + ');padding:30px;border-radius:16px;text-align:center;color:white;margin-bottom:20px;';
    var circle = document.createElement('div');
    circle.style.cssText = 'width:60px;height:60px;background:white;border-radius:50%;margin:0 auto 16px;display:flex;align-items:center;justify-content:center;font-size:24px;font-weight:bold;color:' + primary + ';';
    circle.textContent = state.brand.name.charAt(0).toUpperCase();
    var heading = document.createElement('h3');
    heading.style.cssText = 'margin:0 0 8px;font-size:20px;';
    heading.textContent = state.brand.name;
    wrapper.appendChild(circle);
    wrapper.appendChild(heading);
    if (state.brand.tagline) {
      var tagP = document.createElement('p');
      tagP.style.cssText = 'margin:0;font-size:14px;opacity:0.9;';
      tagP.textContent = state.brand.tagline;
      wrapper.appendChild(tagP);
    }
    preview.appendChild(wrapper);
  }

  function launchBrand() {
    lucySay(`Congratulations! ${state.brand.name} is now live! Welcome to the creator family. Your 5% contributions will support the causes you chose.`);
    closeBrandBuilder();

    setTimeout(() => {
      lucySay("Your creator dashboard is ready. Start designing, selling, and changing the world!");
    }, 2000);
  }
  function selectCategory(category) {
    state.activeProductTab = category;

    document.querySelectorAll('.s3-category-tab').forEach(tab => { tab.classList.toggle('active', tab.dataset.category === category); });

    document.querySelectorAll('.s3-product-group').forEach(group => { group.style.display = group.dataset.category === category ? 'flex' : 'none'; });

    const currentProduct = CONFIG.PRODUCTS[state.product];
    if (!currentProduct || currentProduct.category !== category) {
      const firstProductInCategory = Object.entries(CONFIG.PRODUCTS)
        .find(([key, val]) => val.category === category);
      if (firstProductInCategory) {
        const [productKey] = firstProductInCategory;
        state.product = productKey;
        document.querySelectorAll('.s3-product-type').forEach(b => b.classList.remove('active'));
        document.querySelector(`.s3-product-type[data-product="${productKey}"]`)?.classList.add('active');
        updatePrice();
        updateSizes();
        updateAvailableZones();
        loadS3PrintMethods(productKey);
      }
    }

    const categoryMessages = {
      apparel: "Great choice! Apparel is perfect for showcasing your unique designs.",
      accessories: "Accessories are popular gifts! Phone cases and tote bags are trending.",
      home: "Home decor brings your art into everyday life. Very popular!",
      kids: "Aww, designing for little ones! These make amazing personalized gifts."
    };
    lucySay(categoryMessages[category] || "Nice selection!");
  }

  function updateAvailableZones() {
    const product = CONFIG.PRODUCTS[state.product];
    if (!product) return;
    const availableZones = product.zones || ['front'];
    if (!availableZones.includes(state.activeZone)) {
      state.activeZone = availableZones[0];
    }
    buildZoneStrip();
    selectZone(state.activeZone);
  }

  function showPostGenerationUpsell() {
    const toast = document.createElement('div');
    toast.className = 's3-upsell-toast';
    toast.innerHTML = `
      <div class="s3-toast-content">
        <div class="s3-toast-icon">✨</div>
        <div class="s3-toast-text">
          <strong>Make it officially yours!</strong>
          <p>Add your brand label for just €4.99</p>
        </div>
        <button class="s3-toast-btn" onclick="this.closest('.s3-upsell-toast').remove(); showBrandUpsell();">
          Learn More
        </button>
        <button class="s3-toast-close" onclick="this.closest('.s3-upsell-toast').remove();">×</button>
      </div>
    `;

    if (!document.getElementById('s3ToastStyles')) {
      const styles = document.createElement('style');
      styles.id = 's3ToastStyles';
      styles.textContent = `
        .s3-upsell-toast {
          position: fixed;
          bottom: 24px;
          right: 24px;
          background: linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%);
          border-radius: 16px;
          padding: 16px 20px;
          box-shadow: 0 8px 32px rgba(124, 58, 237, 0.4);
          z-index: 10000;
          animation: s3ToastSlideIn 0.5s ease-out;
          max-width: 340px;
        }
        @keyframes s3ToastSlideIn {
          from { transform: translateX(120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        .s3-toast-content { display: flex; align-items: center; gap: 12px; color: white; }
        .s3-toast-icon { font-size: 28px; flex-shrink: 0; }
        .s3-toast-text { flex: 1; }
        .s3-toast-text strong { display: block; font-size: 14px; margin-bottom: 2px; }
        .s3-toast-text p { font-size: 12px; opacity: 0.9; margin: 0; }
        .s3-toast-btn {
          background: white;
          color: #7c3aed;
          border: none;
          padding: 8px 16px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 13px;
          cursor: pointer;
          white-space: nowrap;
          transition: transform 0.2s;
        }
        .s3-toast-btn:hover { transform: scale(1.05); }
        .s3-toast-close {
          position: absolute;
          top: 8px;
          right: 8px;
          background: none;
          border: none;
          color: white;
          font-size: 18px;
          cursor: pointer;
          opacity: 0.7;
          padding: 0;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .s3-toast-close:hover { opacity: 1; }
      `;
      document.head.appendChild(styles);
    }

    document.body.appendChild(toast);

    setTimeout(() => {
      if (toast.parentNode) {
        toast.style.animation = 'none';
        toast.style.transition = 'transform 0.3s, opacity 0.3s';
        toast.style.transform = 'translateX(120%)';
        toast.style.opacity = '0';
        setTimeout(() => toast.remove(), 300);
      }
    }, 8000);
  }

  function showBrandUpsell() {
    const modal = document.getElementById('s3BrandUpsellModal');
    if (modal) {
      const firstDesign = state.designs.values().next().value;
      if (firstDesign?.url) {
        document.getElementById('s3UpsellProductImg').src = firstDesign.url;
      }
      modal.classList.add('active');
      lucySay("Your design is amazing! Want to make it officially yours with custom brand labels?");
    }
  }

  function closeBrandUpsell() {
    document.getElementById('s3BrandUpsellModal')?.classList.remove('active');
  }

  function skipBranding() {
    closeBrandUpsell();
    if (state.currentTier === 1) {
      proceedToCart();
    }
  }

  function continueToBranding() {
    state.currentTier = 2;
    state.branding.enabled = true;
    closeBrandUpsell();

    showPackagingUpsell();
    updateTierIndicator();
  }

  function showPackagingUpsell() {
    const modal = document.getElementById('s3PackagingModal');
    if (modal) {
      updatePackagingTotal();
      updateGrandTotal();
      modal.classList.add('active');
      lucySay("You've created a brand! Now let's complete the experience with custom packaging.");
    }
  }

  function closePackaging() {
    document.getElementById('s3PackagingModal')?.classList.remove('active');
  }

  function skipPackaging() {
    closePackaging();
    proceedToCart();
  }

  function completeOrder() {
    state.currentTier = 3;
    state.packaging.enabled = true;
    closePackaging();
    proceedToCart();
  }

  function toggleBrandingOption(option, enabled) {
    if (option === 'insidelabel') {
      state.branding.insideLabel.enabled = enabled;
      document.getElementById('s3InsideLabelConfig').style.display = enabled ? 'block' : 'none';
    } else if (option === 'outsidelabel') {
      state.branding.outsideLabel.enabled = enabled;
      document.getElementById('s3OutsideLabelConfig').style.display = enabled ? 'block' : 'none';
    } else if (option === 'hangtag') {
      state.branding.hangTag.enabled = enabled;
      document.getElementById('s3HangTagConfig').style.display = enabled ? 'block' : 'none';
    }
    updateBrandingTotal();
  }

  function togglePackagingOption(option, enabled) {
    if (option === 'custombox') {
      state.packaging.customBox.enabled = enabled;
    } else if (option === 'tissue') {
      state.packaging.tissuePaper.enabled = enabled;
    } else if (option === 'sticker') {
      state.packaging.stickerPack.enabled = enabled;
    } else if (option === 'thankyou') {
      state.packaging.thankYouCard.enabled = enabled;
      document.getElementById('s3ThankYouConfig').style.display = enabled ? 'block' : 'none';
    }
    updatePackagingTotal();
    updateGrandTotal();
  }

  function updateBrandingTotal() {
    let total = 0;
    if (state.branding.insideLabel.enabled) total += CONFIG.BRANDING.inside_label.price;
    if (state.branding.outsideLabel.enabled) total += CONFIG.BRANDING.outside_label.price;
    if (state.branding.hangTag.enabled) total += CONFIG.BRANDING.hang_tag.price;

    document.getElementById('s3BrandingTotal').textContent = `+€${total.toFixed(2)}`;
  }

  function updatePackagingTotal() {
    let total = 0;
    if (state.packaging.customBox.enabled) total += CONFIG.PACKAGING.custom_box.price;
    if (state.packaging.tissuePaper.enabled) total += CONFIG.PACKAGING.tissue_paper.price;
    if (state.packaging.stickerPack.enabled) total += CONFIG.PACKAGING.sticker_pack.price;
    if (state.packaging.thankYouCard.enabled) total += CONFIG.PACKAGING.thank_you_card.price;

    document.getElementById('s3PackagingTotal').textContent = `+€${total.toFixed(2)}`;
  }

  function updateGrandTotal() {
    const baseTotal = calculateTotal();
    let brandingTotal = 0;
    let packagingTotal = 0;

    if (state.branding.enabled) {
      if (state.branding.insideLabel.enabled) brandingTotal += CONFIG.BRANDING.inside_label.price;
      if (state.branding.outsideLabel.enabled) brandingTotal += CONFIG.BRANDING.outside_label.price;
      if (state.branding.hangTag.enabled) brandingTotal += CONFIG.BRANDING.hang_tag.price;
    }

    if (state.packaging.customBox.enabled) packagingTotal += CONFIG.PACKAGING.custom_box.price;
    if (state.packaging.tissuePaper.enabled) packagingTotal += CONFIG.PACKAGING.tissue_paper.price;
    if (state.packaging.stickerPack.enabled) packagingTotal += CONFIG.PACKAGING.sticker_pack.price;
    if (state.packaging.thankYouCard.enabled) packagingTotal += CONFIG.PACKAGING.thank_you_card.price;

    const grandTotal = baseTotal + brandingTotal + packagingTotal;
    document.getElementById('s3GrandTotal').textContent = `€${grandTotal.toFixed(2)}`;
  }

  function updateTierIndicator() {
    document.querySelectorAll('.s3-tier-step').forEach(step => { const tier = parseInt(step.dataset.tier); step.classList.toggle('active', tier === state.currentTier); step.classList.toggle('completed', tier < state.currentTier); });
  }

  function proceedToCart() {
    if (state.currentTier >= 3 && state.packaging.enabled) {
      state.orderTier = 'full_brand';
    } else if (state.currentTier >= 2 && state.branding.enabled) {
      state.orderTier = 'brand_identity';
    } else {
      state.orderTier = 'creative_spark';
    }

    addToCartWithTier();
  }

  async function addToCartWithTier() {
    const cartBtn = document.getElementById('s3AddToCart');
    /* WOW 2026-09-26 cart dead-links (docs/reports/2026-09-26-cart-and-lucy-fixes.md): this studio has no print route of
       its own (its cart variant was a DRAFT product, no print file, no Gelato size/colour check). Orders go through the
       AI Design Studio, which is proven end to end. T-shirt and hoodie hand off there; other products are not orderable yet. */
    {
      const _k = state.product === 'hoodie' ? 'Hoodie' : (state.product === 'tshirt' ? 'T-Shirt' : null);
      if (_k) {
        lucySay("To order, I'll take you to the AI Design Studio. It prints on the real " + (_k === 'Hoodie' ? 'hoodie' : 'T-shirt') + " and checks your size and colour. Make your final design there.");
        if (cartBtn) { cartBtn.disabled = true; cartBtn.innerHTML = 'Opening the AI Design Studio…'; }
        setTimeout(function () { window.location.href = '/pages/ai-creative-studio?product=' + encodeURIComponent(_k); }, 2200);
      } else {
        lucySay("This product can't be ordered yet. The T-shirt and the hoodie can: pick one of those to order.");
      }
      return;
    }
    if (cartBtn) {
      cartBtn.disabled = true;
      cartBtn.innerHTML = '⏳ Adding...';
    }

    try {
      const properties = {
        '_product_type': state.product,
        '_size': state.size,
        '_color': state.color,
        '_order_tier': state.orderTier,
        '_virtue_contribution': (calculateTotalWithAddons() * CONFIG.VIRTUE_PERCENTAGE).toFixed(2)
      };

      state.designs.forEach((design, zone) => {
        properties[`_${zone}_url`] = design.url;
        properties[`_${zone}_prompt`] = design.prompt;
      });

      if (state.branding.enabled) {
        if (state.branding.insideLabel.enabled) {
          properties['_inside_label'] = 'true';
          properties['_inside_label_design'] = state.branding.insideLabel.design || 'pending';
        }
        if (state.branding.outsideLabel.enabled) {
          properties['_outside_label'] = 'true';
          properties['_outside_label_design'] = state.branding.outsideLabel.design || 'pending';
        }
        if (state.branding.hangTag.enabled) {
          properties['_hang_tag'] = 'true';
          properties['_hang_tag_design'] = state.branding.hangTag.design || 'pending';
        }
      }

      if (state.packaging.customBox.enabled) properties['_custom_box'] = 'true';
      if (state.packaging.tissuePaper.enabled) properties['_tissue_paper'] = 'true';
      if (state.packaging.stickerPack.enabled) properties['_sticker_pack'] = 'true';
      if (state.packaging.thankYouCard.enabled) {
        properties['_thank_you_card'] = 'true';
        properties['_thank_you_message'] = document.getElementById('s3ThankYouMessage')?.value || '';
      }

      const variantId = getVariantId();

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: state.quantity,
            properties: properties
          }]
        })
      });

      const data = await response.json();

      if (data.items || data.id) {
        showSuccess();
        const tierMessages = {
          creative_spark: "Added to cart! Your AI design is ready for checkout.",
          brand_identity: "Your branded product is in the cart! Custom labels included.",
          full_brand: "Full brand experience added! Your customers will love the unboxing."
        };
        lucySay(tierMessages[state.orderTier] + " Remember, 5% goes to the cause you choose!");
      } else {
        throw new Error('Cart add failed');
      }

    } catch (error) {
      lucySay("Couldn't add to cart. Let's try again.");
    } finally {
      if (cartBtn) {
        cartBtn.disabled = false;
        cartBtn.innerHTML = '<span class="s3-cart-icon">🛒</span><span class="s3-cart-text">Add to Cart</span>';
      }
    }
  }

  function calculateTotalWithAddons() {
    let total = calculateTotal();

    if (state.branding.enabled) {
      if (state.branding.insideLabel.enabled) total += CONFIG.BRANDING.inside_label.price;
      if (state.branding.outsideLabel.enabled) total += CONFIG.BRANDING.outside_label.price;
      if (state.branding.hangTag.enabled) total += CONFIG.BRANDING.hang_tag.price;
    }

    if (state.packaging.customBox.enabled) total += CONFIG.PACKAGING.custom_box.price;
    if (state.packaging.tissuePaper.enabled) total += CONFIG.PACKAGING.tissue_paper.price;
    if (state.packaging.stickerPack.enabled) total += CONFIG.PACKAGING.sticker_pack.price;
    if (state.packaging.thankYouCard.enabled) total += CONFIG.PACKAGING.thank_you_card.price;

    return total;
  }
  function updateUI() {
    updateCharCount();
    updatePrice();
    updateOrderItems();
    updateClosetCount();
  }

  function updateCharCount() {
    els.charCount.textContent = els.prompt.value.length;
  }

  function showGenerating() {
    els.generating.classList.add('active');
    els.genBar.style.width = '0%';
    els.genTip.textContent = `Tip: ${CONFIG.TIPS[Math.floor(Math.random() * CONFIG.TIPS.length)]}`;

    let progress = 0;
    const interval = setInterval(() => {
      progress += Math.random() * 15;
      if (progress >= 90) {
        clearInterval(interval);
        progress = 90;
      }
      els.genBar.style.width = `${progress}%`;
    }, 400);
  }

  function hideGenerating() {
    els.genBar.style.width = '100%';
    setTimeout(() => {
      els.generating.classList.remove('active');
    }, 300);
  }

  function showSuccess() {
    els.successModal.classList.add('active');
  }

  function createAnother() {
    els.successModal.classList.remove('active');
    state.designs.clear();
    state.activeZone = 'front';
    els.prompt.value = '';
    updateCharCount();

    document.querySelectorAll('.s3-zone-tab').forEach(tab => { tab.classList.remove('has-design'); });

    document.querySelectorAll('.s3-design-zone').forEach(zone => { zone.classList.remove('has-design'); resetZonePlaceholder(zone); });

    selectZone('front');
    updateOrderItems();
    updatePrice();
    lucySay("Fresh canvas ready! What would you like to create?");
  }

  function startWordRotation() {
    let index = 0;
    setInterval(() => {
      index = (index + 1) % CONFIG.WORD_ROTATE.length;
      if (els.wordRotate) {
        els.wordRotate.style.opacity = 0;
        setTimeout(() => {
          els.wordRotate.textContent = CONFIG.WORD_ROTATE[index];
          els.wordRotate.style.opacity = 1;
        }, 300);
      }
    }, 3000);
  }
  (function initDykRotation() {
    var tips = [
      '5% of each sale goes to a cause you choose',
      'You can design on multiple zones — front, back, sleeves',
      'Try Embroidery mode for premium stitched designs 🧵',
      'Your designs are saved across sessions — come back anytime',
      'Earn 10-20% as a Creator by sharing your designs',
      'All products are printed on demand',
      'Lucy can help — just ask her anything about design!',
      'Gift-ready packaging available from €6.99'
    ];
    var dykEl = document.getElementById('s3DykText');
    if (!dykEl) return;
    var di = 0;
    setInterval(function() {
      di = (di + 1) % tips.length;
      dykEl.style.opacity = '0';
      setTimeout(function() {
        dykEl.textContent = tips[di];
        dykEl.style.opacity = '1';
      }, 400);
    }, 6000);
  })();

  function initMovementMaker() {
    const movementModal = document.getElementById('s3MovementModal');
    const startBtn = document.getElementById('s3StartMovement');
    const closeBtn = document.getElementById('s3CloseMovement');
    const launchBtn = document.getElementById('s3LaunchMovement');
    const goalSlider = document.getElementById('s3GoalAmount');
    const goalValue = document.querySelector('.s3-goal-value');

    startBtn?.addEventListener('click', () => { movementModal.classList.add('active'); lucySay("Let's create something meaningful! What cause speaks to your heart?"); });

    closeBtn?.addEventListener('click', () => {
      movementModal.classList.remove('active');
    });

    document.querySelectorAll('.s3-campaign-join').forEach(btn => {
      btn.addEventListener('click', function() {
        const cause = this.dataset.cause;
        lucySay(`Amazing choice! You're joining the ${cause} movement. Let's design for change!`);

        document.getElementById('s3Studio')?.scrollIntoView({ behavior: 'smooth' });

        const themePrompts = {
          climate: "Nature design with trees, leaves, and Earth in harmonious green tones",
          ocean: "Majestic ocean waves with marine life, coral reefs, and deep blue colors",
          education: "Inspiring design with books, light bulbs, and symbols of knowledge and growth",
          health: "Calming wellness design with healing hearts, nature, and soothing colors"
        };

        if (themePrompts[cause] && els.prompt) {
          els.prompt.value = themePrompts[cause];
          updateCharCount();
        }
      });
    });

    document.querySelectorAll('.s3-cause-btn').forEach(btn => { btn.addEventListener('click', function() { document.querySelectorAll('.s3-cause-btn').forEach(b => b.classList.remove('active')); this.classList.add('active'); });
    });

    goalSlider?.addEventListener('input', function() {
      const value = parseInt(this.value);
      goalValue.textContent = `€${value.toLocaleString()}`;
    });

    launchBtn?.addEventListener('click', () => {
      const name = document.getElementById('s3MovementName')?.value.trim();
      const story = document.getElementById('s3MovementStory')?.value.trim();
      const goal = goalSlider?.value || 1000;
      const cause = document.querySelector('.s3-cause-btn.active')?.dataset.sdg;

      if (!name) { lucySay("Give your movement a name first! Something that inspires action."); return; }

      const movement = {
        id: Date.now(),
        name: name,
        story: story,
        goal: parseInt(goal),
        raised: 0,
        cause: cause,
        createdAt: new Date().toISOString(),
        supporters: 0
      };

      let movements = JSON.parse(localStorage.getItem('s3_movements') || '[]');
      movements.push(movement);
      localStorage.setItem('s3_movements', JSON.stringify(movements));

      movementModal.classList.remove('active');
      lucySay(`🎉 ${name} is LIVE! Share your movement and start designing products that fund your cause. You're a changemaker now!`);

      showMovementSuccess(name);
    });
  }

  function showMovementSuccess(name) {
    const notification = document.createElement('div');
    notification.className = 's3-movement-success';
    var msContent = document.createElement('div');
    msContent.className = 's3-ms-content';
    var msIcon = document.createElement('span');
    msIcon.className = 's3-ms-icon';
    msIcon.textContent = '\u{1F680}';
    var msTextDiv = document.createElement('div');
    msTextDiv.className = 's3-ms-text';
    var msStrong = document.createElement('strong');
    msStrong.textContent = name;
    var msLive = document.createTextNode(' is now live!');
    var msSub = document.createElement('span');
    msSub.textContent = 'Start designing to fund your cause';
    msTextDiv.appendChild(msStrong);
    msTextDiv.appendChild(msLive);
    msTextDiv.appendChild(msSub);
    var msClose = document.createElement('button');
    msClose.className = 's3-ms-close';
    msClose.textContent = '\u00D7';
    msContent.appendChild(msIcon);
    msContent.appendChild(msTextDiv);
    msContent.appendChild(msClose);
    notification.appendChild(msContent);

    notification.style.cssText = `
      position: fixed;
      bottom: 24px;
      right: 24px;
      background: linear-gradient(135deg, #10B981, #34D399);
      color: white;
      padding: 16px 24px;
      border-radius: 16px;
      box-shadow: 0 8px 30px rgba(16, 185, 129, 0.4);
      z-index: 2000;
      animation: slideInRight 0.5s ease;
    `;

    document.body.appendChild(notification);

    notification.querySelector('.s3-ms-close').addEventListener('click', () => { notification.remove(); });

    setTimeout(() => notification.remove(), 5000);
  }
  window.selectStarterKit = function(kitType) {
    const kits = {
      nature: {
        name: 'Nature Lover',
        cause: 'climate',
        sdg: 13,
        prompts: [
          "Majestic forest scene with towering trees and morning mist, earth-toned colors",
          "Abstract leaf pattern forming a heart shape, green and gold tones",
          "Mountain landscape at sunrise with wildflowers, fresh outdoor vibes",
          "Geometric nature mandala with leaves, branches, and earthy textures",
          "Wildlife silhouettes against forest backdrop, nature conservation theme"
        ],
        products: ['tshirt', 'totebag'],
        message: "Welcome to the Nature Lover kit! 🌿 Your kit includes 5 nature-inspired designs. Let's create something beautiful!"
      },
      ocean: {
        name: 'Ocean Guardian',
        cause: 'ocean',
        sdg: 14,
        prompts: [
          "Majestic whale swimming through coral reef, deep blue ocean tones",
          "Abstract ocean waves with marine life silhouettes, teal and white",
          "Sea turtle among tropical fish, vibrant underwater scene",
          "Minimalist wave pattern with moon reflection, peaceful ocean night",
          "Coral reef ecosystem with colorful fish, marine conservation theme"
        ],
        products: ['tshirt', 'hoodie'],
        message: "Welcome to Ocean Guardian! 🐋 Your kit includes 5 ocean-themed designs. Let's create something beautiful!"
      },
      education: {
        name: 'Education Champion',
        cause: 'education',
        sdg: 4,
        prompts: [
          "Open book with magical light streaming out, knowledge and wonder theme",
          "Globe surrounded by books and graduation caps, world education",
          "Tree of knowledge with books as leaves, growth and learning",
          "Inspirational typography design about learning and dreams",
          "Children reading under a starry sky, imagination and education"
        ],
        products: ['tshirt', 'mug'],
        message: "Welcome to Education Champion! 📚 Your kit includes 5 inspirational designs. Let's create something beautiful!"
      }
    };

    const kit = kits[kitType];
    if (!kit) return;

    localStorage.setItem('s3_active_kit', JSON.stringify({
      type: kitType,
      ...kit,
      selectedAt: Date.now()
    }));

    document.querySelector('.s3-studio')?.scrollIntoView({ behavior: 'smooth' });

    if (els.prompt) {
      els.prompt.value = kit.prompts[0];
      updateCharCount();
    }

    lucySay(kit.message);

    const notification = document.createElement('div');
    notification.className = 's3-kit-activated';
    var kitContent = document.createElement('div');
    kitContent.className = 's3-kit-notif-content';
    var kitIcon = document.createElement('span');
    kitIcon.className = 's3-kit-notif-icon';
    kitIcon.textContent = '\u{1F381}';
    var kitTextDiv = document.createElement('div');
    kitTextDiv.className = 's3-kit-notif-text';
    var kitStrong = document.createElement('strong');
    kitStrong.textContent = kit.name + ' Kit Activated!';
    var kitSub = document.createElement('span');
    kitSub.textContent = '5 themed prompts loaded \u2022 Ready to create';
    kitTextDiv.appendChild(kitStrong);
    kitTextDiv.appendChild(kitSub);
    var kitClose = document.createElement('button');
    kitClose.textContent = '\u00D7';
    kitClose.addEventListener('click', function() { notification.remove(); });
    kitContent.appendChild(kitIcon);
    kitContent.appendChild(kitTextDiv);
    kitContent.appendChild(kitClose);
    notification.appendChild(kitContent);
    notification.style.cssText = `
      position: fixed;
      top: 24px;
      right: 24px;
      background: linear-gradient(135deg, #10B981, #059669);
      color: white;
      padding: 16px 20px;
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(16, 185, 129, 0.4);
      z-index: 10000;
      animation: slideInRight 0.5s ease;
    `;

    if (!document.getElementById('s3KitAnimStyles')) {
      const style = document.createElement('style');
      style.id = 's3KitAnimStyles';
      style.textContent = `
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        .s3-kit-notif-content { display: flex; align-items: center; gap: 12px; }
        .s3-kit-notif-icon { font-size: 24px; }
        .s3-kit-notif-text { display: flex; flex-direction: column; gap: 2px; }
        .s3-kit-notif-text strong { font-size: 14px; }
        .s3-kit-notif-text span { font-size: 12px; opacity: 0.9; }
        .s3-kit-activated button { background: rgba(255,255,255,0.2); border: none; color: white; width: 24px; height: 24px; border-radius: 50%; cursor: pointer; font-size: 16px; }
      `;
      document.head.appendChild(style);
    }

    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 5000);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
(function() {
  var byl = document.querySelector('before-you-leave');
  if (byl) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'class' && byl.classList.contains('open')) {
          byl.classList.remove('open');
          document.documentElement.classList.remove('open-drawer', 'open-byl');
          document.documentElement.style.removeProperty('padding-right');
        }
      });
    });
    observer.observe(byl, { attributes: true, attributeFilter: ['class'] });
  }
})();
(function() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('edit') === 'true') {
    const script = document.createElement('script');
    script.src = window.__S3.assets['s3-visual-editor.js'];
    script.onload = () => {};
    document.head.appendChild(script);
  }
})();

